<template>
  <div class="sp-template">
    <div class="h-title">订单管理</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :model="conditions" class="header-search__form" :inline="true" size="small" label-width="90px">
          <el-row>
            <el-form-item label="订单状态">
              <el-select v-model.lazy="conditions.stages" filterable clearable multiple>
                <el-option v-for="(d, i) in tmsOrderStages" :key="i" :label="'已'+d.name" :value="d.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="审核状态">
              <el-select v-model.lazy="conditions.audit" clearable>
                <el-option v-for="(d, i) in tmsOrderAuditStatus" :key="i" :label="d.name" :value="d.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户">
              <el-select v-model.lazy="conditions.orgOwner" filterable clearable multiple>
                <el-option v-for="(d, i) in customerList" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="仓库">
              <el-select v-model.lazy="conditions.warehouseIds" filterable clearable multiple>
                <el-option v-for="(d, i) in warehouses" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产品">
              <el-select v-model="conditions.product" filterable clearable multiple>
                <el-option v-for="(d, i) in channelDatas" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单号">
              <el-input v-model="conditions.numberTextArea" type="textarea" placeholder="多个单号用回车分割"></el-input>
            </el-form-item>
          </el-row>
          <el-collapse-transition>
						<div v-show="isSearchMore">
              <el-row>
                <el-form-item label="客服">
                  <el-select v-model.lazy="conditions.customerServiceStaffs" filterable clearable multiple>
                    <el-option v-for="(d, i) in customerServiceStaffs" :key="i" :label="d.name" :value="d.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="业务员">
                  <el-select v-model.lazy="conditions.salesmans" filterable clearable multiple>
                    <el-option v-for="(d, i) in salesmans" :key="i" :label="d.name" :value="d.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="FBA号">
                <el-input v-model="conditions.fbaNumberTextArea" type="textarea" placeholder="多个FBA号用回车分割"></el-input>
              </el-form-item>
							</el-row>
              <el-row>
                <el-form-item label="开始日期">
                  <el-date-picker v-model="conditions.startDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                  <el-date-picker v-model="conditions.endDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="客户订单号">
                  <el-input v-model="conditions.customerOrderNumberTextArea" type="textarea" placeholder="多个单号用回车分割"></el-input>
                </el-form-item>
							</el-row>
              <el-row>
                <el-form-item label="转单号">
                  <el-input v-model="conditions.trackingNumberTextArea" type="textarea" placeholder="多个单号用回车分割"></el-input>
                </el-form-item>
                <el-form-item label="批次号">
                  <el-input v-model="conditions.batchIdTextArea" type="textarea" placeholder="多个批次号用回车分割"></el-input>
                </el-form-item>
                <el-form-item label="通配搜索">
                  <el-input v-model="conditions.wildcardTextsTextArea" type="textarea" :autosize="{ minRows: 3, maxRows: 5 }"
                    placeholder="目前支持订单号、客户订单号、转单号、批次号、FBA号同时匹配，多个用回车分割">
                  </el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="FBA仓码">
                  <el-select v-model.lazy="conditions.fbaWarehouseCode" filterable clearable>
                    <el-option v-for="(d, i) in initialDataFbaAddress" :key="i" :label="d.name" :value="d.name"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="客户类型">
                  <el-select v-model.trim.lazy="conditions.customerType" clearable>
                    <el-option v-for="(d, i) in customerTypeList" :key="i" :label="d.name" :value="d.value"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="分公司">
                  <el-select v-model.lazy="conditions.companyId" clearable>
                    <el-option v-for="(d, i) in companys" :key="i" :label="d.name" :value="d.id"></el-option>
                  </el-select>
                </el-form-item>

              </el-row>
              <el-row>
                <el-form-item label="过滤条件">
                  <el-checkbox v-model="conditions.barringBatchId">批次号为空</el-checkbox>
                  <el-checkbox v-model="conditions.barringRefNumber">转单号为空</el-checkbox>
                  <el-checkbox v-model="conditions.detainGoods">扣货订单</el-checkbox>
                  <el-checkbox v-model="conditions.generalTrade">一般贸易</el-checkbox>
                  <el-checkbox v-model="conditions.purchaseInsurance">保险订单</el-checkbox>
                </el-form-item>
              </el-row>
						</div>
          </el-collapse-transition>
          <div class="search-form__buttons">
            <el-button v-if="in_configs(312)" size="small" type="primary" @click="search">搜索</el-button>
            <el-button v-if="in_configs(312)" size="small" @click="reset">清空</el-button>
            <a class="toggle-icon" @click.stop.prevent="isSearchMore = !isSearchMore">
              <b v-if="isSearchMore">隐藏</b>
              <b v-else>切换到</b>高级搜索</a>
          </div>
        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="conditions.status" @tab-click="onSubmit">
          <el-tab-pane v-if="in_configs(314)" label="未处理" name="未处理"></el-tab-pane>
          <el-tab-pane v-if="in_configs(315)" label="完成" name="完成"></el-tab-pane>
          <el-tab-pane v-if="in_configs(334)" label="异常订单" name="异常订单"></el-tab-pane>
        </el-tabs>
        <div class="button-groups">
          <el-button size="small" @click="customizeDialogVisible = true">自定义列表显示项</el-button>
          <el-button v-show="in_configs(301) && conditions.status == '未处理'" size="small" @click="dialogFormVisible = true">新建订单</el-button>
          <el-button v-show="in_configs(302) && conditions.status == '未处理'" size="small" @click="showDialogUpLoadDialog">上传订单</el-button>
          <el-button v-show="in_configs(304) && conditions.status == '完成'" size="small" title="请先勾选订单" @click="downloadCartonLabel">下载面单</el-button>
          <el-dropdown trigger="click" style="margin-left: 10px;" >
            <el-button size="small">导出信息<i class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-show="in_configs(316)" @click.native="downloadGoodsInfo">导出订单信息表</el-dropdown-item>
              <el-dropdown-item v-show="in_configs(318)" @click.native="goodsInfoExport()">导出货物信息</el-dropdown-item>
              <el-dropdown-item v-show="in_configs(320)" @click.native="downloadInTheOrderInfo">导出在库订单信息</el-dropdown-item>
              <el-dropdown-item v-show="in_configs(324)" @click.native="generatedReportByCustomer">导出客户时效表</el-dropdown-item>
              <el-dropdown-item v-show="in_configs(330)" @click.native="trackingNoExport">导出转单号</el-dropdown-item>
              <el-dropdown-item v-show="in_configs(330)" @click.native="invoiceTemplateExport2">导出发票</el-dropdown-item>
              <el-dropdown-item v-show="in_configs(330)" @click.native="wuyoubao">导出无忧保模板</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown trigger="click" style="margin-left: 10px;">
            <el-button size="small">操作订单<i class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-show="in_configs(307) && conditions.status == '未处理'" title="请先勾选未扣货订单" :disabled="disabledDetainGoodsBtn" @click.native="detainGoods(false)">扣货</el-dropdown-item>
              <el-dropdown-item v-show="in_configs(308) && conditions.status == '异常订单'" title="请先勾选已扣货订单" :disabled="disabledreleaseGoodsBtn" @click.native="releaseGoods(false)">扣货放行</el-dropdown-item>
              <el-dropdown-item v-show="in_configs(305) && conditions.status == '完成'" size="small" title="请先勾选订单">获取提货码</el-dropdown-item>
              <el-dropdown-item v-show="in_configs(313)" @click.native="transferNumberPop()">转单</el-dropdown-item>
              <el-dropdown-item v-show="in_configs(335)" @click.native="confirmShipping()">确认发货</el-dropdown-item>
              <el-dropdown-item v-show="in_configs(309) && conditions.status == '未处理'" title="请先勾要退件订单" @click.native="backOrder()">退件</el-dropdown-item>
              <el-dropdown-item v-show="in_configs(336) && conditions.status == '未处理'" title="请先勾要审核的订单" @click.native="batchAudit()">批量审核订单</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <el-table ref="multipleTable" :data="tableData" border stripe tooltip-effect="dark" style="width:100%" max-height="800" v-loading="loading" element-loading-text="拼命加载中，请稍候" @selection-change="handleSelectionChange" >
        <el-table-column type="selection" ></el-table-column>
        <el-table-column label="订单号"  v-if="customizeShowColumns.id" >
          <template slot-scope="scope">
            <div>
              <div>{{scope.row.id}}</div>
              <div v-if="scope.row.overWeight" class="name-tooltips third" style="background:red">超重</div>
              <div v-if="scope.row.overSize" class="name-tooltips third" style="background:red">超长</div>
              <div v-if="scope.row.largeParcel" class="name-tooltips third" style="background:red">大型</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="customerName" label="客户" v-if="customizeShowColumns.customerName" >
        </el-table-column>
        <el-table-column prop="customerOrderNumber" label="客户订单号" v-if="customizeShowColumns.customerOrderNumber" ></el-table-column>
        <el-table-column label="FBA号" v-if="customizeShowColumns.fbaNumber"  :key="101">
          <template slot-scope="scope">
            <div v-if="scope.row.customerRefnumber && scope.row.customerRefnumber.fbaNumber">
              {{scope.row.customerRefnumber.fbaNumber}}
              <br>
              {{scope.row.amazonReferenceId}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="仓库" v-if="customizeShowColumns.warehousCode" :key="102" >
          <template slot-scope="scope">{{warehouseMap[scope.row.warehousCode]}}</template>
        </el-table-column>
        <el-table-column label="批次号" v-if="customizeShowColumns.batchIds" :key="103" >
          <template slot-scope="scope">
            <p v-for="(d,i) in scope.row.batchIds" :key="i">{{d}}</p>
          </template>
        </el-table-column>
        <el-table-column label="转单号" v-if="customizeShowColumns.trackingNumbers" :key="104" >
          <template slot-scope="scope">
            <p v-for="(d,i) in scope.row.masterTrackingNumber" :key="i">
              <a v-if="d && d.substring(0,2) == '1Z'" target="_blank" style="border-bottom:1px solid;" :href="'https://www.ups.com/track?loc=en_US&tracknum='+d+'&requester=WT/trackdetails'" :class="{'active':scope.row.sameTrackingNumber==false}">{{d}}</a>
              <a v-else-if="d && (d.substring(0,2) == '78'|| d.substring(0,2) == '39')" target="_blank" style="border-bottom:1px solid;"
               :href="'https://www.fedex.com/apps/fedextrack/?tracknumber='+d" :class="{'active':scope.row.sameTrackingNumber==false}"
                >{{d}}</a>
              <span v-else >{{d}}</span>
              <el-button size="mini" type="text" @click="editTrackingNumberPop(scope.row, d)">
                <i class="el-icon-edit" title="编辑转单号"></i>
              </el-button>
              <el-button size="mini" type="text" @click="delTrackingNumber(scope.row, d)" style="color: red;">
                <i class="el-icon-circle-close-outline" title="删除转单号"></i>
              </el-button>
            </p>
            <el-button size="mini" v-show="scope.row.trackingNumbers && scope.row.trackingNumbers.length >0 && scope.row.masterTrackingNumber &&  scope.row.masterTrackingNumber.length>0" type="text" @click="showTrackingNumber(scope.row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="productName" label="产品" v-if="customizeShowColumns.productName"  :key="105"></el-table-column>
        <el-table-column prop="packingList.totalCarton" label="货物箱数" v-if="customizeShowColumns.totalCarton" :key="106" ></el-table-column>
        <el-table-column label="客户预报重量(kg)" v-if="customizeShowColumns.yuBaoWeight" :key="107" >
          <template slot-scope="scope">
            {{calculateTotalWeight(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column label="实测重量(kg)" v-if="customizeShowColumns.shiCeWeight" :key="108" >
          <template slot-scope="scope">
            {{calculateTotalActuallyWeight(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column label="计费重 (kg/m³)" v-if="customizeShowColumns.chargingWeight" :key="109" >
          <template slot-scope="scope">
            {{scope.row.orderChargeValue && scope.row.orderChargeValue.chargingWeight ? toFixed(scope.row.orderChargeValue.chargingWeight,4) : ""}}
          </template>
        </el-table-column>
        <el-table-column prop="orderChargeValue.totalAmount" label="总运费" v-if="customizeShowColumns.totalAmount"  :key="110"></el-table-column>
        <el-table-column prop="goodsTypeName" label="货物类型" v-if="customizeShowColumns.goodsTypeName"  :key="111"></el-table-column>
        <el-table-column label="一般贸易" v-if="customizeShowColumns.generalTrade" :key="112" >
          <template slot-scope="scope">{{scope.row.generalTrade?"是":"否"}}</template>
        </el-table-column>
        <el-table-column label="分公司" v-if="customizeShowColumns.company" :key="130" >
          <template slot-scope="scope">{{companyMap[scope.row.companyId]}}</template>
        </el-table-column>

        <el-table-column prop="customerServiceStaff" label="客服" v-if="customizeShowColumns.customerServiceStaff" :key="113" ></el-table-column>
        <el-table-column prop="salesman" label="业务员" v-if="customizeShowColumns.salesman" :key="114" ></el-table-column>
        <el-table-column prop="costAmountLocked" label="应付锁定" v-if="customizeShowColumns.costAmountLocked" :key="115" >
          <template slot-scope="scope">{{scope.row.costAmountLocked ? "已锁":"未锁"}}</template>
        </el-table-column>
        <el-table-column prop="salesAmountLocked" label="应收锁定" v-if="customizeShowColumns.salesAmountLocked" :key="116" >
             <template slot-scope="scope">{{scope.row.salesAmountLocked ? "已锁":"未锁"}}</template>
        </el-table-column>
        <el-table-column prop="shippingDetail.address.zipcode" label="邮编" v-if="customizeShowColumns.zipcode" :key="117" ></el-table-column>
        <el-table-column prop="statusName" label="当前状态" v-if="customizeShowColumns.statusName" :key="118"></el-table-column>
        <el-table-column prop="nextStatusName" label="下一状态" v-if="customizeShowColumns.nextStatusName" :key="119" ></el-table-column>
        <el-table-column label="扣货状态" v-if="customizeShowColumns.detainGoods" :key="120" >
          <template slot-scope="scope">{{scope.row.detainGoods ? "已扣货":"正常"}}</template>
        </el-table-column>
        <el-table-column label="审核状态" v-if="customizeShowColumns.audit"  :key="121">
          <template slot-scope="scope">{{scope.row.audit ? "已审核":"待审核"}}</template>
        </el-table-column>
        <el-table-column prop="createAt" label="下单时间" v-if="customizeShowColumns.createAt" :key="122" ></el-table-column>
        <el-table-column label="操作" width="80" fixed="right">
          <template slot-scope="scope">
            <el-dropdown trigger="click" >
              <el-button plain size="small">...</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="in_configs(309)" size="mini" type="text" @click.native="showDetail(scope.row.id)">
                  查看订单详情
                </el-dropdown-item>
                <el-dropdown-item v-if="in_configs(306) && conditions.status !== '完成' && scope.row.status !== 'canceled' && scope.row.edit !==false && (scope.row.status == 'new'
                    || scope.row.status == 'audited' || scope.row.status == 'pick_up_from_customer' || scope.row.status == 'receipt' || scope.row.status == 'measure' 
                    || scope.row.status == 'need_to_confirm' || scope.row.status == 'separate_quote' )" type="text" @click.native="editOrder(scope.row)">
                  编辑订单
                </el-dropdown-item>
                <el-dropdown-item v-if="in_configs(328) && conditions.status !== '完成' && scope.row.status !== 'canceled' && scope.row.edit !==false && (scope.row.status == 'new'
                    || scope.row.status == 'audited' || scope.row.status == 'pick_up_from_customer' || scope.row.status == 'receipt' || scope.row.status == 'measure' 
                    || scope.row.status == 'need_to_confirm' || scope.row.status == 'separate_quote')" type="text" @click.native="editUploadOrder(scope.row)">
                  编辑上传
                </el-dropdown-item>
                <el-dropdown-item v-if="in_configs(303) && !scope.row.audit" size="mini" type="text" @click.native="setingAudit(scope.row.id)">
                  订单审核
                </el-dropdown-item>
                <el-dropdown-item v-if="in_configs(310)" size="mini" type="text" @click.native="handlePrintPop(scope.row.id)">
                  打印箱标
                </el-dropdown-item>
                <el-dropdown-item v-if="in_configs(333)" size="mini" type="text" @click.native="invoiceTemplateExport(scope.row.id,scope.row.detainGoods,scope.row.nonSysException,scope.row.customerName)">
                  导出超安达模板
                </el-dropdown-item>
                <el-dropdown-item v-if="in_configs(311)" size="mini" type="text" @click.native="downloadAttachment(scope.row.id,scope.row.detainGoods,scope.row.nonSysException)">
                  下载附件
                </el-dropdown-item>
                <el-dropdown-item class="not-flex" v-if="in_configs(321)" @click.native="downloadTemplate(scope.row)">
                  <a href="#">下载源文件</a>
                </el-dropdown-item>
                <el-dropdown-item v-if="in_configs(322) && scope.row.attachmentUrl !== null" size="mini" type="text" @click.native="downloadAttachedFiles(scope.row.id)">
                  下载附加文件
                </el-dropdown-item>
                <el-dropdown-item v-if="in_configs(319) && showCancelBtn.indexOf(scope.row.statusName) != -1 " size="mini" type="text" @click.native="cancelOrder(scope.$index, scope.row)" style="color: #F56C6C;">
                  取消订单
                </el-dropdown-item>
                <el-dropdown-item v-if="in_configs(325) && (!scope.row.nonSysException) " size="mini" type="text" @click.native="addExceptionOrder(scope.$index, scope.row)" style="color: #F56C6C;">
                  添加异常
                </el-dropdown-item>
                <el-dropdown-item v-if="in_configs(326) && (scope.row.nonSysException) " size="mini" type="text" @click.native="addExceptionOrder(scope.$index, scope.row)" style="color: #F56C6C;">
                  解除异常
                </el-dropdown-item>
                <el-dropdown-item v-if="in_configs(327)" size="mini" type="text" @click.native="addOrderRemarks(scope.row.id)">
                  查看备注
                </el-dropdown-item>
                <el-dropdown-item v-if="in_configs(331)" size="mini" type="text" @click.native="popOrderEditLog(scope.row.id)">
                  查看订单编辑记录
                </el-dropdown-item>
                <el-dropdown-item v-if="in_configs(331)" size="mini" type="text" @click.native="findTrack(scope.row.id)">
                  查看轨迹
                </el-dropdown-item>
                <el-dropdown-item size="mini" type="text" @click.native="measureImage(scope.row.id)">
                  下载测量图片
                </el-dropdown-item>
                <el-dropdown-item size="mini" type="text" @click.native="showFbaNumberPop(scope.row.id)">
                  查看亚马逊单号
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="conditions.currentPage" :page-sizes="[10, 20, 50, 100, 200, 500]" :page-size="conditions.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

    <!-- 提示弹框2 -->
    
    <!-- 提示框3（异常跟踪） -->
    <el-dialog title="添加异常跟踪" :visible.sync="dialogCheckVisible4" width="30%">
      <el-form size="small">
        <el-form-item label="时间" :label-width="formLabelWidth80" class="require">
          <el-date-picker v-model="trackingInfo.createAt" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="描述" :label-width="formLabelWidth80" class="require">
          <el-input v-model.trim="trackingInfo.content" type="textarea" placeholder="描述" :autosize="{ minRows: 2}"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogCheckVisible4 = false">取 消</el-button>
        <el-button size="small" type="primary" @click="addExceptionFollowInfo()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- ppppp查看订单编辑历史弹层 -->
    <el-dialog title="订单编辑历史" :visible.sync="orderEditLogsVisible" width="50%">

      <el-table style="width: 100%" :data="orderEditLogs">
        <el-table-column label="时间" prop="operationAt"></el-table-column>
        <el-table-column label="描述">
          <template slot-scope="scope">
            <div v-for="(d, i) in scope.row.operationObject.values" :key="i">
              <span v-if="d.name!='产品名称'">{{d.name}}： 原始值：{{d.originValue}} 修改值：{{d.newValue}}</span>
              <span v-if="d.name=='产品名称'">{{d.name}}： 原始值：{{channelDatasMap[d.originValue]}} 修改值：{{channelDatasMap[d.newValue]}}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作人">
          <template slot-scope="scope">
            {{scope.row.operator}}
          </template>
        </el-table-column>

      </el-table>
    </el-dialog>

    <!-- 添加备注弹层 -->
    <el-dialog title="订单备注" :visible.sync="addOrderRemarksVisible" width="800px">
      <div style="margin-bottom: 20px; text-align: right;">
        <el-button size="small" type="primary" plain v-if="in_configs(329)" @click="addOrderRemarksDialogVisible=true">添加备注</el-button>
      </div>
      <el-table style="width: 100%" border :data="orderRemarks">
        <el-table-column label="时间" prop="createdAt"></el-table-column>
        <el-table-column label="事件" prop="event"></el-table-column>
        <el-table-column label="描述" prop="content"></el-table-column>
        <el-table-column label="操作人" prop="operator"></el-table-column>
        <el-table-column label="图片">
          <template slot-scope="scope">
            <!-- <img v-image-preview v-if="scope.row.imgUrl" :src="scope.row.imgUrl" title="点击查看大图" style="max-height: 40px;max-width: 40px"/> -->
            <!-- <img v-if="scope.row.imgUrl.indexOf('oss-cn-shenzhen.aliyuncs.com') !== -1 && scope.row.imgUrl !=='data:image/png;base64,null'" 
              :src="scope.row.imgUrl" 
              title="点击查看大图" 
              width="40" 
              height="40" 
              style="cursor: pointer;" 
              @click="showImg"> -->
            <img :src="scope.row.imgUrl" width="40" height="40" style="cursor: pointer;" @click="showImg">
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 查看备注大图 -->
    <transition name="el-fade-in-linear">
      <div class="modal" v-show="imgDialogShow" @click="closeModal()">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="img-wrapper">
              <!-- <div class="close" @click="closeModal()">
                <i class="el-icon-circle-close-outline"></i>
              </div> -->
              <img id="imgContent" src="" alt="" style="max-width: 800px; max-height: 800px;">
            </div>
          </div>
        </div>
      </div>
    </transition>
    <el-dialog title="添加备注" :visible.sync="addOrderRemarksDialogVisible" width="30%">
      <el-form size="small" :model="orderRemarksForm" ref="orderRemarksForm" :rules="rulesOrderRemarks">
        <el-form-item label="事件" :label-width="formLabelWidth80" prop="event">
          <el-input type="text" v-model.trim="orderRemarksForm.event" placeholder="事件"></el-input>
        </el-form-item>

        <el-form-item label="描述" :label-width="formLabelWidth80" prop="content">
          <el-input v-model.trim="orderRemarksForm.content" type="textarea" placeholder="描述" :autosize="{ minRows: 2}"></el-input>
        </el-form-item>

        <el-form-item label="上传图片" :label-width="formLabelWidth80" prop="img">
          <el-upload action="#" :file-list="imgFile" list-type="picture-card" :limit="1" :on-change="imgChange" :auto-upload="false">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addOrderRemarksDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="addRemarks()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 新建订单 -->
    <el-dialog title="新建订单" class="fullwidth-form__dialog" :visible.sync="dialogFormVisible" width="450px">
      <el-form :model="createOrderform" size="small" :rules="createOrderformRules" ref="createOrderform" label-width="80px" label-position="left">
        <el-form-item label="客户名称" prop="customer">
          <el-select v-model="createOrderform.customer" @change="getCustomerChannel(false)" clearable filterable>
            <el-option v-for="(c,i) in customerList" :key="i" :label="c.name" :value="c.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品名称" prop="product">
          <el-select v-model="createOrderform.product" clearable filterable >
            <el-option v-for="(p,i) in channelData" :key="i" :label="p.name" :value="p.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="newOrder">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 上传订单 -->
    <el-dialog title="上传订单" class="upload-order__dialog" :visible.sync="dialogUpLoadVisible" width="50%">
      <el-form :model="uploadForm" size="small">
        <el-form-item label="客户名称" :label-width="formLabelWidth" prop="customer">
          <el-select v-model="uploadForm.customer" @change="getCustomerChannel(true)" clearable filterable>
            <el-option v-for="(c,i) in customerList" :key="i" :label="c.name" :value="c.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品名称" :label-width="formLabelWidth" prop="product">
          <el-select v-model="uploadForm.product" clearable filterable>
            <el-option v-for="(p,i) in channelData" :key="i" :label="p.name" :value="p.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="取件方式" :label-width="formLabelWidth">
          <el-radio v-model="uploadForm.deliveryDetail.deliveryType" @change="changedeliveryType" label="PICK_UP_FROM_CUSTOMER">预约上门取件</el-radio>
          <el-tooltip class="item" effect="dark" content="我们将在1-2天内上门取件，为收货方便，请提前准备好货物！当运费小于500元时，按货物重量收取费用，详情请查看《上门取件上说明》" placement="right">
            <i class="el-icon-question"></i>
          </el-tooltip>
          <el-button size="mini" type="text">《上门取件上说明》</el-button>
          <br />
          <el-radio v-model="uploadForm.deliveryDetail.deliveryType" @change="changedeliveryType" label="DELIVERY">送货至仓库</el-radio>
          <el-tooltip class="item" effect="dark" content="请根据您的货物地址，选择距离货物最近的收货仓库" placement="right">
            <i class="el-icon-question"></i>
          </el-tooltip>
          <br />
          <el-radio v-model="uploadForm.deliveryDetail.deliveryType" @change="changedeliveryType" label="DELIVERY_BY_EXPRESS">快递至仓库</el-radio>
          <el-tooltip class="item" effect="dark" content="请根据您的货物地址，选择距离货物最近的收货仓库" placement="right">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </el-form-item>

        <el-form-item label="取件地址" :label-width="formLabelWidth" v-show="uploadForm.deliveryDetail.deliveryType=='PICK_UP_FROM_CUSTOMER'">
          <el-select v-model="shippingId" placeholder="请选择" @change="selectShippingAddress" v-show="uploadForm.deliveryDetail.deliveryType=='PICK_UP_FROM_CUSTOMER'" clearable filterable>
            <el-option v-for="item in shippingList" :key="item.id" :label="item.address" :value="item.id">
              <span>{{ item.country+" "+item.province+" "+item.city+" "+item.address+" "+item.name+" "+item.phone}}</span>
            </el-option>
          </el-select>
          <el-button size="small" type="info" plain @click="addressDialogPop()" v-show="uploadForm.deliveryDetail.deliveryType=='PICK_UP_FROM_CUSTOMER'">添加地址</el-button>

          <el-table :data="new Array(uploadForm.deliveryDetail)" :show-header="false" class="table-list" style="width: 100%" v-show="uploadForm.deliveryDetail.deliveryType == 'PICK_UP_FROM_CUSTOMER' && false">
            <el-table-column prop="province" label="地址" width="70"></el-table-column>
            <el-table-column prop="city" label="地址" width="90"></el-table-column>
            <el-table-column prop="addressFirst" label="地址" width="260"></el-table-column>
            <el-table-column prop="contractName" label="联系人" width="100"></el-table-column>
            <el-table-column prop="phone" label="电话" width="120"></el-table-column>
            <el-table-column label="操作" width="60">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="handleEditAddress(scope.$index, scope.row)">编辑地址</el-button>
              </template>
            </el-table-column>
          </el-table>

        </el-form-item>

        <el-form-item label="交货仓库地址" :label-width="formLabelWidth">
          <el-select v-model="warehouseId" filterable v-if="flag" placeholder="请选择" @change="selectWarehouse">
            <el-option v-for="item in warehouseData" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-table :data="userCarry" :show-header="false" class="table-list" style="width: 100%">
            <el-table-column label="仓库名称" width="230">
              <template slot-scope="scope">
                {{scope.row.title}}
              </template>
            </el-table-column>
            <el-table-column label="地址" width="230">
              <template slot-scope="scope">
                {{scope.row.address}}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="联系人" width="100"></el-table-column>
            <el-table-column prop="phone" label="电话" width="120"></el-table-column>
          </el-table>
        </el-form-item>

        <el-form-item :label="uploadForm.deliveryDetail.deliveryType == 'PICK_UP_FROM_CUSTOMER' ? '预约取件时间' : '预计送达时间'" :label-width="formLabelWidth" v-show="uploadForm.deliveryDetail.deliveryType!='DELIVERY_BY_EXPRESS'">
          <el-date-picker v-model="uploadForm.deliveryDetail.appointmentAt" :picker-options="appointmentAtOptions" type="datetime" 
          placeholder="选择日期" style="width: 280px;">
          </el-date-picker>
        </el-form-item>
        <el-row>
          <el-col :span="10" prop="expressCompany">
            <el-form-item label="快递公司" :label-width="formLabelWidth" v-show="uploadForm.deliveryDetail.deliveryType == 'DELIVERY_BY_EXPRESS'">
              <el-input v-model="uploadForm.deliveryDetail.expressCompany" auto-complete="off" placeholder="快递公司"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10" prop="expressNumber">
            <el-form-item label="快递单号" :label-width="formLabelWidth" v-show="uploadForm.deliveryDetail.deliveryType == 'DELIVERY_BY_EXPRESS'">
              <el-input v-model="uploadForm.deliveryDetail.expressNumber" auto-complete="off" placeholder="快递单号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="模板下载" :label-width="formLabelWidth">
          <a href="../../static/template/newFBA-US-A-sample.xlsx" class="template-btn">美国空运模板</a>
          <a href="../../static/template/FBA-A-sample.xlsx" class="template-btn">其他空运模板</a>
          <a href="../../static/template/newFBA-S-sample.xlsx" class="template-btn">国际海运模板</a>
          <a href="../../static/template/railway-sample.xlsx" class="template-btn">国际铁运模板</a>
          <!-- <a href="../../static/template/FBA-T-sample.xlsx" class="template-btn">国际铁运模板</a> --> 
        </el-form-item>

        <el-form-item label="文件上传" :label-width="formLabelWidth">
          <el-upload class="upload-demo" ref="uploadExcel" action="#" :limit="1" :on-exceed="exceedFile" :file-list="fileList" :on-change="fileChange" :auto-upload="false" accept=".xlsx">
            <el-button size="small">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xlsx(Excel2007)文件，且不超过10M</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeUploadFile()">取 消</el-button>
        <el-button size="small" type="primary" @click="orderUpload">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 订单审核 -->
    <!--
    <el-dialog title="订单审核" :visible.sync="dialogCheckVisible">
      您确定要审核成功吗？
      <el-form :model="checkForm" size="small">
        <el-form-item label="审核" :label-width="formLabelWidth">
          <el-radio v-model="checkForm.audit" label='true'>通过</el-radio>
          <el-radio v-model="checkForm.audit" label='false'>不通过</el-radio>
        </el-form-item>
        <el-form-item label="原因" :label-width="formLabelWidth" v-show="checkForm.audit=='false'">
          <el-input v-model="checkForm.auditRemark" placeholder="不通过原因"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogCheckVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="setingAudit">确 定</el-button>
      </div>
    </el-dialog>
    -->
    <el-dialog title="订单上传更新" :visible.sync="dialogCheckVisibleEditUpload" width="30%">
      <el-form :model="editForm" size="small">
        <el-form-item label="文件上传">
          <el-upload class="upload-demo" ref="uploadExcel" action="#" :limit="1" :on-exceed="exceedFile" :file-list="fileList" :on-change="fileChange" :auto-upload="false" accept=".xlsx">
            <el-button size="small" type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip" style="padding-left: 70px;">只能上传xlsx(Excel2007)文件，且不超过10M</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogCheckVisibleEditUpload = false">取 消</el-button>
        <el-button size="small" type="primary" @click="editUploadOrderInfo">确 定</el-button>
      </div>
    </el-dialog>
    
    <el-dialog title="明细" :visible.sync="showTrackingNumberWindow">
      <p v-for="(d,i) in trackingNumbers" :key="i"><span v-if="manualTrackingNumbers.indexOf(d)!=-1" style="color:red;">*</span>{{d}}</p>
    </el-dialog>
    <!-- 编辑转单号 弹框 -->
    <el-dialog title="编辑转单号" :visible.sync="showEditTrackingNumber" width="25%">
      <el-form size="small" label-width="80px">
        <el-form-item label="原转单号">
          {{theEditTrackingNumber}}
        </el-form-item> <br />
        <el-form-item label="转单号">
          <el-input type="text" v-model="newTrackingNumber" placeholder="转单号" autofocus="autofocus"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showEditTrackingNumber = false">取 消</el-button>
        <el-button size="small" type="primary" @click="editTrackingNumber()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 转单页面 -->
    <el-dialog title="转单" :visible.sync="transferNumberVisible" width="800px">
      <transfer-content :form="transferForm" v-on:closeTransferPanel="closeTransferPanel()" />
    </el-dialog>

    <!-- 添加地址 -->
    <el-dialog title="添加地址" :visible.sync="addressDialogVisible" width="500px" class="fullwidth-form__dialog">
			<el-form size="small" label-width="100px" label-position="left" :model="shippingForm" :rules="rulesShippingForm" ref="shippingForm" class="edit-address__from">
        <el-form-item label="国家" prop="country">
          <el-select v-model="shippingForm.country" placeholder="国家" filterable>
            <el-option v-for="item in initialDataCountry" :key="item.id" :label="item.nameCn" :value="item.nameCn"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="省" prop="province">
          <el-select v-model="shippingForm.province" placeholder="省" @change="queryCity" filterable>
            <el-option v-for="item in initialDataProvince" :key="item.id" :label="item.nameCn" :value="item.nameCn"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="市" prop="city">
          <el-select v-model="shippingForm.city" placeholder="市" filterable>
            <el-option v-for="item in initialDataCity" :key="item.id" :label="item.nameCn" :value="item.nameCn"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="shippingForm.address" placeholder="详细地址"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="name">
          <el-input v-model="shippingForm.name" placeholder="联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model.number="shippingForm.phone" placeholder="联系电话"></el-input>
        </el-form-item>
        <el-form-item label="邮政编码" prop="zipcode">
          <el-input v-model="shippingForm.zipcode" placeholder="邮政编码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="shippingForm.defaultAddress">设为默认地址</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right;">
        <el-button type="primary" size="small" @click.native="fahandleSaveAddress()">保 存</el-button>
      </div>
		</el-dialog>

    <form action="" method="get" target="_blank" id="myform">
    </form>
    <form action="" method="post" target="_blank" id="exportform">
    </form>

    <!-- 提示弹框2 -->
    <el-dialog title="打印箱标" :visible.sync="dialogCheckVisible2" width="25%">
      <el-form size="small">
        <el-form-item label="打印规格">
          <el-select v-model="printType" style="width: 80%;">
            <el-option v-for="(d, i) in printTypes" :key="i" :label="d.name" :value="d.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogCheckVisible2 = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handlePrint()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- fbanumber 查询窗口 -->
    <el-dialog title="亚马逊单号查询" :visible.sync="dialogFbaNumberVisible" width="800" v-dialogDrag>

      <div v-show="fbaNumberList.length>0" style="margin: 0px 0px 20px 0;font-size:700;">订单号：{{ fbaNumberList && fbaNumberList.length > 0 ? fbaNumberList[0].orderId : ''}} 
        <el-button size="small" type="primary" @click="exportFbaNumber()" style="margin-left:50px;" >导出</el-button>
      </div>
      <el-table :data="fbaNumberList" stripe border style="width: 1200px" >
        <el-table-column prop="trackingNumber" label="快递单号" align="center"></el-table-column>
        <el-table-column prop="fbaNumber" label="亚马逊单号" align="center"></el-table-column>
        <el-table-column prop="createdAt" label="扫描时间" align="center"></el-table-column>
        <!-- <el-table-column prop="" label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="small" type="danger" @click="delTrack(scope.row)" style="margin-left:20px;">删除</el-button>
          </template>
        </el-table-column> -->
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFbaNumberVisible = false">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 自定义列表展示项 -->
		<customize-columns
			:tablename = "tablename"
			:customizeDialogVisible = customizeDialogVisible
			:customizeShowColumns = customizeShowColumns
			@selectedColumns = selectedColumns
			@closeCustomizeDialog = closeCustomizeDialog>
		</customize-columns>
  	<!-- 查看轨迹弹窗 -->
            <el-dialog title="查看轨迹" :visible.sync="TrackdialogShow" width="40%" :close-on-click-modal="false">
            <el-table :data="order_trackData" border ref="cpbatchtable" height="400px" >
              <el-table-column  label="批次轨迹" align="center">
                <template slot-scope="scope">
                   <span>{{1}}</span>
                </template>
              </el-table-column>
              <el-table-column  label="详情"  align="center" >
                <template slot-scope="scope">
                   <span>{{2}}</span>
                </template>
              </el-table-column>
              <el-table-column  label="计划时间" align="center">
                <template slot-scope="scope">
                   <span>{{3}}</span>
                </template>
              </el-table-column>
              <el-table-column  label="实际时间" align="center">
                <template slot-scope="scope" >
                   <span>{{4}}</span>
                </template>
              </el-table-column>
              <el-table-column  label="备注" align="center">
                <template slot-scope="scope" >
                   <span>{{4}}</span>
                </template>
              </el-table-column>
               <el-table-column  label="操作" align="center">
                <template slot-scope="scope" >
                   <el-button type="text">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
      </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import TransferContent from "../orderOperation/TransferContent";
import customizeColumns from "../../components/customize-columns";
import { mapState, mapMutations } from "vuex";
import { base64ToUint8Array, dateFormat } from '@/util/formUtil'
export default {
  data() {
    return {
      TrackdialogShow:false, // 查看轨迹弹窗是否显示变量  
      order_trackData:[],
      showCancelBtn: ["新增", "审核", "单独报价", "上门取货"],
      warehouses: [],
      warehouseMap: {},
      tablename: "订单列表",
      customizeDialogVisible: false,
      customizeShowColumns: {
        id: true,
        customerName: true,
        customerOrderNumber: true,
        fbaNumber: false,
        warehousCode: false,
        batchIds: false,
        trackingNumbers: false,
        productName: true,
        totalCarton: true,
        yuBaoWeight: false,
        shiCeWeight: false,
        chargingWeight: false,
        totalAmount: true,
        goodsTypeName: true,
        generalTrade: true,
        createAt: true,
        customerServiceStaff: false,
        salesman: false,
        statusName: true,
        nextStatusName: true,
        detainGoods: false,
        audit: true,
        zipcode: false,
        costAmountLocked:false,//应付锁定
        salesAmountLocked:false //应付锁定
      },
      isJP: false,
      imgDialogShow: false,
      dialogCheckVisible3: false,
      dialogCheckVisible4: false,
      dialogCheckVisibleEditUpload: false,
      trackingInfo: {
        eventName: "",
        content: "",
        trackingNumber: "",
        createAt: "",
        orderId: ""
      },
      dialogCheckVisible2: false,
      printType: "SINGLE",
      printTypes: [
        { id: "SINGLE", name: "100x100" },
        { id: "A4", name: "A4" }
      ],
      thePrintId: "",
      conditions: {
        stages: [],
        audit: "",
        orgOwner: [],
        warehouseIds: [],
        product: [],
        numberTextArea: "",
        customerServiceStaffs: [],
        salesmans: [],
        fbaNumberTextArea: "",
        customerOrderNumberTextArea: "",
        startDate: "",
        endDate: "",
        trackingNumberTextArea: "",
        batchIdTextArea: "",
        wildcardTextsTextArea: "",
        barringBatchId: false,
        barringRefNumber: false,
        detainGoods: false,
        generalTrade: false,
        purchaseInsurance: false,
        status: "未处理",
        currentPage: 1,
        pageSize: 10,
        export: 0,
        fbaWarehouseCode: "",
        customerType: "",
        companyId: ""
      },
      tableData: [],
      multipleSelection: [],
      customerList: [],
      tmsOrderStages: [],
      tmsOrderAuditStatus: [],
      form: {
        product: "",
        customer: ""
      },
      uploadForm: {
        orgOwner: "",
        orgOp: "",
        customer: "",
        product: "",
        productType: "",
        productCountry: "",
        warehouseId: "",
        customsId: "",
        deliveryDetail: {
          deliveryType: "PICK_UP_FROM_CUSTOMER",
          warehouseCode: "",
          appointmentAt: new Date(),
          expressCompany: "",
          expressNumber: "",
          contractName: "",
          phone: "",
          country: "",
          province: "",
          city: "",
          addressFirst: ""
        }
      },
      orderRemarksForm: {
        orderId: "",
        event: "",
        content: "",
        img: ""
      },
      orderRemarks: [],
      orderEditLogs: [],
      addImg: "",
      imgFile: [],
      dialogImageUrl: "", //上传图片
      dialogVisible: false,
      fileList: [],
      templateFile: "",
      loading: true,
      isSearchMore: false,
      dialogFormVisible: false,
      dialogUpLoadVisible: false,
      dialogCheckVisible: false,
      addOrderRemarksVisible: false,
      orderEditLogsVisible: false,
      addOrderRemarksDialogVisible: false,
      formLabelWidth: "120px",
      formLabelWidth80: "80px",
      formLabelWidth100: "100px",
      checkForm: {
        audit: false,
        auditRemark: null
      },
      editForm: {
        orderId: "",
        orgOwner: "",
        orgOp: "",
        warehousCode: "",
        productId: "",
        product: "",
        remark: "",
        warehouseId: "",
        customerRefnumber: { customerOrderNumber: "", fbaNumber: "" },
        deliveryDetail: {
          deliveryType: "PICK_UP_FROM_CUSTOMER",
          warehouseCode: "",
          appointmentAt: new Date(),
          expressCompany: "",
          expressNumber: "",
          contractName: "",
          phone: "",
          country: "",
          province: "",
          city: "",
          addressFirst: ""
        }
      },
      total: 0,
      createOrderform: {
        product: "",
        customer: ""
      },
      createOrderformRules: {
        product: [{ required: true, message: "请选择产品", trigger: "change" }],
        customer: [{ required: true, message: "请选择客户", trigger: "change" }]
      },
      channelDatas: [],
      channelDatasMap: {},
      channelData: [],
      numberTextArea: "",
      show: false,
      showCost: false,
      guigeRadio: "1",
      productChecked: false,
      listTable: false,
      spList: [],
      guigeArr: [
        {
          number: "12",
          long: "12",
          width: "12",
          height: "12",
          weight: "12"
        }
      ],
      showTrackingNumberWindow: false,
      trackingNumbers: [],
      //转单
      transferNumberVisible: false,
      transferForm: {
        items: [{ number: "", trackingNumber: "" }],
        type: "UPS"
      },
      editCartonStatus: [
        "capacity_allocation",
        "batch_operation",
        "shipping",
        "origin_scan",
        "delivery"
      ],
      disabledDetainGoodsBtn: true,
      disabledreleaseGoodsBtn: true,
      //当前登录人信息
      currentUserInfo: {
        userId: "",
        userName: "",
        sysOwner: false, //组织拥有者
        saleman: false, //业务员
        serviceStaff: false //客服
      },
      salesmans: [],
      customerServiceStaffs: [],
      appointmentAtOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "明天",
            onClick(picker) {
              let _tomorrow = new Date(
                new Date(
                  new Date().getTime() + 3600 * 1000 * 24
                ).toLocaleDateString()
              );
              picker.$emit("pick", _tomorrow);
            }
          },
          {
            text: "后天",
            onClick(picker) {
              let _afterTomorrow = new Date(
                new Date(
                  new Date().getTime() + 3600 * 1000 * 24 * 2
                ).toLocaleDateString()
              );
              picker.$emit("pick", _afterTomorrow);
            }
          }
        ],
        disabledDate(time) {
          return time < new Date(new Date().toLocaleDateString()).getTime();
        }
      },
      shippingId: "",
      shippingList: [],
      userCarry: [
        {
          title: "",
          address: "",
          name: "",
          phone: "",
          distance: ""
        }
      ],
      flag: false,
      warehouseData: [],
      warehouse: [],
      isInit: true,
      warehouseId: "",
      rulesShippingForm: {
        country: [{ required: true, message: "请选择国家", trigger: "change" }],
        province: [
          { required: true, message: "请选择省(直辖市、区)", trigger: "change" }
        ],
        city: [{ required: true, message: "请选择城市", trigger: "change" }],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
          { min: 10, message: "详细地址不可少于10字符", trigger: "blur" }
        ],
        zipcode: [
          { required: true, message: "请输入邮政编码", trigger: "blur" }
        ],
        fbaWarehouseCode: [
          { required: true, message: "请选择FBA仓码", trigger: "change" }
        ],
        name: [
          { required: true, message: "请输入寄件人姓名", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入寄件人手机号码", trigger: "blur" }
          // {
          //   pattern: /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$/,
          //   message: "手机号码格式不正确",
          //   trigger: "blur"
          // }
        ]
      },
      rulesOrderRemarks: {
        event: [{ required: true, message: "请输入事件", trigger: "blur" }],
        content: [{ required: true, message: "请输入描述", trigger: "blur" }]
      },
      initialDataCountry: [],
      initialDataProvince: [],
      initialDataCity: [],
      addressDialogVisible: false,
      shippingForm: {
        id: "",
        country: "",
        province: "",
        city: "",
        fbacode: "",
        address: "",
        name: "",
        phone: "",
        zipcode: "",
        type: "SHIPPING",
        defaultAddress: false
      },
      needInitData: true,
      showEditTrackingNumber: false,
      theEditTrackingNumber: "",
      newTrackingNumber: "",
      theOrderId: "",
      initialDataFbaAddress: [],
      customerTypeList:[],//客户类型List 
      returnMessage:'',
      companys: [],
      companyMap: {},
      fbaNumberList: [],
      dialogFbaNumberVisible: false

    };
  },
  components: {
    TransferContent,
    customizeColumns
  },
  computed: {
    ...mapState([
      "manualTrackingNumbers",
      "orderListTable",
      "orderListConditions",
      "orderListSearchMore"
    ])
  },
  beforeRouteEnter(to, from, next) {
    if (from.path === "/checkorder" || from.path === "/editorder") {
      next(vm => {
        vm.tableData = vm.orderListTable;
        vm.conditions = vm.orderListConditions;
        vm.isSearchMore = vm.orderListSearchMore;
        vm.total = vm.orderListTable.length;
        vm.needInitData = false;
      });
    } else {
      next();
    }
  },
  created() {
    if (localStorage.getItem("customizeTmsOpOrderColumns")) {
      let customizeTmsOpOrderColumns = JSON.parse(
        localStorage.getItem("customizeTmsOpOrderColumns")
      );
      this._initCustomizeTmsOpOrderColumns(customizeTmsOpOrderColumns);
    }
    setTimeout(() => {
      this.loadTmsOrderStages();
      this.loadTmsOrderAuditStatus();
      this.findByCustomerName();
      this.findAllChannle();
      this.queryProvinceOfChina();
      this.initData();
      this.queryFbaAddress();
      this.getCustomerType()
      this.queryCompany();
      this.loading = false;
    }, 1000);
  },
  methods: {
    ...mapMutations([
      "setManualTrackingNumbers",
      "setOrderListTable",
      "setOrderListConditions",
      "setOrderListSearchMore"
    ]),
    // 接收自定义列表显示项组件的数据并关闭弹层
    closeCustomizeDialog(val) {
      this.customizeDialogVisible = val;
    },
    // 接收自定义列表显示项组件的数据并赋值给customizeShowColumns对象
    selectedColumns(val) {
      this._initCustomizeTmsOpOrderColumns(val);
      this.customizeDialogVisible = false;
    },
    // 给自定义列表项的对象赋值
    _initCustomizeTmsOpOrderColumns(val) {
      for (let key in val) {
        this.customizeShowColumns[key] = val[key];
      }
    },
    // 添加备注---查看大图
    showImg() {
      let src = event.target.src;
      if (
        src.indexOf("oss-cn-shenzhen.aliyuncs.com") === -1 ||
        src === "data:image/png;base64,null"
      ) {
        return;
      }
      this.imgDialogShow = true;
      var imgContent = document.getElementById("imgContent");
      imgContent.src = src;
    },
    closeModal() {
      this.imgDialogShow = false;
    },
    // 下载模板
    downloadTemplate(row) {
      // 测试用的id和url
      // id = 'ITDEA1807250003'
      // let url = `https://starpost-test.oss-cn-shenzhen.aliyuncs.com/${id}-upload-excel.xlsx`
      // let url = `https://starpost-public-read.oss-cn-shenzhen.aliyuncs.com/${id}-upload-excel.xlsx`;
      // let url = `${OSS_BASEURL}${id}-upload-excel.xlsx`;

      let url = row.sourceFileUrl
      let parent = event.target;
      parent.setAttribute("href", url);
      parent.setAttribute("target", "_blank");
    },
    // 下载附加文件
    downloadAttachedFiles(id) {
      this.$windowOpen1(
        '/order/download/attachedFiles' +
          "?orderId=" +
          id
      );
    },
    // 清空搜索条件
    reset() {
      this.conditions = {
        stages: [],
        audit: "",
        orgOwner: [],
        warehouseIds: [],
        product: [],
        numberTextArea: "",
        customerServiceStaffs: [],
        salesmans: [],
        fbaNumberTextArea: "",
        customerOrderNumberTextArea: "",
        startDate: "",
        endDate: "",
        trackingNumberTextArea: "",
        batchIdTextArea: "",
        wildcardTextsTextArea: "",
        barringBatchId: false,
        barringRefNumber: false,
        detainGoods: false,
        generalTrade: false,
        purchaseInsurance: false,
        status: "未处理",
        currentPage: 1,
        pageSize: 10,
        export: 0,
        fbaWarehouseCode: ""
      };
      this.onSubmit();
    },
    initData() {
      let _this = this;
      let urlArray = [this.findCurrentUserInfo(), this.findAllWarehouse()]; // unknown # of urls (1 or more)

      _this.$axios.all(urlArray).then(
        _this.$axios.spread(function(responseUserInfo, warehouseData) {
          _this.initCurrentData(responseUserInfo);
          _this.initWarehouseData(warehouseData);
          if (_this.needInitData) {
            _this.search();
          }
        })
      );
    },
    initWarehouseData(data) {
      let _this = this;
      _this.warehouses = data.data;
      _this.warehouses.forEach(a => {
        _this.warehouseMap[a.id] = a.name;
      });
    },
    //获取仓库
    findAllWarehouse() {
      return this.$request1.get(
        '/warehouse/staff',
        {
          withCredentials: true
        }
      );
    },
    // 分公司 
    queryCompany(){
        let _this = this;
        this.$request1({
            method: 'get',
            url: '/system/company',
            params: {
              page:  1,
              pageSize: -1
            }
        })
        .then(response => {          
            _this.companys = response.data.data;
            _this.companys.forEach(a => {
                _this.companyMap[a.id] = a.name;
            });
        })
        .catch(error => {
          console.log(error);
        });
    },
    findCurrentUserInfo() {
      return this.$request1.get(
        '/staff/current-role'
      );
    },
    initCurrentData(responseUserInfo) {
      // this.currentUserInfo = responseUserInfo.data;
      // if (this.currentUserInfo.saleman === true) {
      //   this.loadRoleList("客服");
      // } else if (this.currentUserInfo.serviceStaff === true) {
      //   this.loadRoleList("业务员");
      // } else {
      //   this.loadRoleList("业务员");
      //   this.loadRoleList("客服");
      // }
      this.loadRoleList("业务员");
      this.loadRoleList("客服");
    },
    //查询业务员和客服
    loadRoleList(role) {
      let _this = this;
      _this.$request1
        .get(
          '/staffrole',
          {
            params: {
              role: role
            }
          },
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            if (role == "业务员") {
              _this.salesmans = res.data.data;
            } else if (role == "客服") {
              _this.customerServiceStaffs = res.data.data;
            }
          } else {
            _this.salesmans = [];
            _this.customerServiceStaffs = [];
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    search() {
      this.conditions.currentPage = 1;
      this.onSubmit();
    },
    // 处理查询表单数据
    handleConditionsData() {
      //过滤仓库
      let wlist = [];
      if (this.warehouses != null && this.warehouses.length > 0) {
        if (
          this.conditions.warehouseIds &&
          this.conditions.warehouseIds.length > 0
        ) {
          wlist = this.conditions.warehouseIds;
        } else {
          wlist = this.warehouses.map(a => a.id);
        }
      } else {
        wlist.push("NOT MATCHING");
      }
      let conditions = {
        searchException: this.conditions.status == "异常订单", //增加异常状态查询
        isDone: this.conditions.status == "完成",
        productIds: this.conditions.product,
        orderId: [],
        batchId: [],
        customerOrderNumber: [],
        trackingNumber: [],
        orgOwners: this.conditions.orgOwner,
        warehouseIds: wlist,
        stages: this.conditions.stages,
        audit: this.conditions.audit,
        startDate: this.conditions.startDate,
        endDate: this.conditions.endDate,
        currentPage: this.conditions.currentPage,
        pageSize: this.conditions.pageSize,
        barringBatchId: this.conditions.barringBatchId,
        barringRefNumber: this.conditions.barringRefNumber,
        detainGoods: this.conditions.detainGoods,
        wildcardTexts: [],
        customerServiceStaffs: this.conditions.customerServiceStaffs,
        salesmans: this.conditions.salesmans,
        sysOwner: this.currentUserInfo.sysOwner,
        saleman: this.currentUserInfo.saleman,
        serviceStaff: this.currentUserInfo.serviceStaff,
        generalTrade: this.conditions.generalTrade,
        purchaseInsurance: this.conditions.purchaseInsurance,
        fbaNumber: [],
        export: this.conditions.export,
        fbaWarehouseCode: this.conditions.fbaWarehouseCode,
        customerType: this.conditions.customerType,
        companyId:  this.conditions.companyId
      };

      if(this.conditions.numberTextArea){
        this.conditions.numberTextArea.split(/\n+/gim).forEach((d, i) => {
          if (d && d != "") {
            conditions.orderId.push(d);
          }
        });
      }
      if(this.conditions.customerOrderNumberTextArea){
        this.conditions.customerOrderNumberTextArea
        .split(/\n+/gim)
        .forEach((d, i) => {
          if (d && d != "") {
            conditions.customerOrderNumber.push(d);
          }
        });
      }
      if(this.conditions.trackingNumberTextArea){
        this.conditions.trackingNumberTextArea.split(/\n+/gim).forEach((d, i) => {
          if (d && d != "") {
            conditions.trackingNumber.push(d);
          }
        });
      }
      if(this.conditions.batchIdTextArea){
        this.conditions.batchIdTextArea.split(/\n+/gim).forEach((d, i) => {
          if (d && d != "") {
            conditions.batchId.push(d);
          }
        });
      }
      
      if(this.conditions.fbaNumberTextArea){
        this.conditions.fbaNumberTextArea.split(/\n+/gim).forEach((d, i) => {
          if (d && d != "") {
            conditions.fbaNumber.push(d);
          }
        });
      }
      if(this.conditions.wildcardTextsTextArea){
        this.conditions.wildcardTextsTextArea.split(/\n+/gim).forEach((d, i) => {
          if (d && d != "") {
            conditions.wildcardTexts.push(d);
          }
        });
      }
      
      if (
        this.conditions.status == "完成" ||
        this.conditions.status == "异常订单" ||
        this.conditions.status == "未处理"
      ) {
        this.conditions.export = 0;
      }
      return conditions;
    },
    //搜索
    onSubmit() {
      let conditions = this.handleConditionsData();
      
        this.$request1({
            method: 'post',
            url: '/order/query',
            data: conditions
          })
        .then(res => {
          // console.log(res.data.message)
          if (res.data.success) {
            this.tableData = res.data.data;
            this.total = res.data.total;
            if (this.tableData.length > 0) {
              this.setManualTrackingNumbers(
                this.tableData[0].manualTrackingNumbers
              );
            }
          } else {
            this.tableData = [];
            this.total = 0;
            this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          this.tableData = [];
          this.total = 0;
          console.log(error);
        });
    },
    showDetail(id) {
      this.$router.push({
        path: "/checkorder",
        query: {
          id: id,
          searchException: this.conditions.status == "异常订单"
        }
      });
      this.setOrderListTable(this.tableData);
      this.setOrderListConditions(this.conditions);
      this.setOrderListSearchMore(this.isSearchMore);

      // this.loadData(id);
      // this.loadCost(id);
      // this.trackingInfo.orderId = id;
    },

    handlePrintPop(val) {
      this.dialogCheckVisible2 = true;
      this.thePrintId = val;
    },
    handlePrint() {
      this.dialogCheckVisible2 = false;
      let url = '/order/print/' + this.thePrintId + '/' + this.printType + '';
      this.$windowOpen1(url);
    },
    //编辑订单
    editOrder(rowOrder) {
      // this.$notify.info({
      //   title: "提示",
      //   message: "功能开发中"
      // });
      // console.log(orderId);
      let orderId = rowOrder.id;
      let rowOrderStatus = rowOrder.status;
      //console.log(orderId, rowOrderStatus);
      let editCarton = true;
      if (this.editCartonStatus.indexOf(rowOrderStatus) != -1) {
        editCarton = false;
      }
      this.$router.push({
        path: "/editorder",
        query: {
          orderId: orderId,
          editCarton: editCarton
        }
      });
      this.setOrderListTable(this.tableData);
      this.setOrderListConditions(this.conditions);
      this.setOrderListSearchMore(this.isSearchMore);
    },
    newOrder() {
      let _this = this;
      _this.$refs["createOrderform"].validate(valid => {
        if (valid) {
          _this.dialogFormVisible = false;
          this.$router.push(
            "/neworder?customer=" +
              _this.createOrderform.customer +
              "&product=" +
              _this.createOrderform.product
          );
        } else {
          return false;
        }
      });
    },
    addOrderRemarks(orderId) {
      let _this = this;
      //清空
      _this.orderRemarksForm = {};
      _this.addImg = "";
      _this.imgFile = [];
      //获取备注记录
      _this.$request1
        .get(
          '/order/queryOrderRemarks',
          {
            params: {
              orderId: orderId
            }
          },
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            _this.orderRemarks = res.data.data;
          }
        })
        .catch(function(error) {
          console.log(error);
        });

      _this.addOrderRemarksVisible = true;
      _this.orderRemarksForm.orderId = orderId;
    },
    popOrderEditLog(orderId) {
      let _this = this;
      this.orderEditLogsVisible = true;
      _this.$request1
        .get(
          '/order/edit-log/' + orderId + '',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            _this.orderEditLogs = res.data.data;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getFormData(form, pic) {
      let _this = this;
      var formData = new FormData();
      for (var key in form) {
        formData.append(key, form[key]);
      }
      formData.append("pic", pic);
      return formData;
    },
    addOrderRemarksVisibleMethod() {
      let _this = this;
      _this.addOrderRemarksVisible = !this.addOrderRemarksVisible;
    },
    addRemarks() {
      let _this = this;
      let _valid = true;
      _this.$refs["orderRemarksForm"].validate(valid => {
        if (!valid) {
          _valid = false;
        }
      });
      if (!_valid) {
        return false;
      }

      let form = _this.orderRemarksForm;
      let formData = _this.getFormData(form, _this.addImg);

      _this.$request1
        .post(
          '/order/addOrderRemarks',
          formData,
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.status == 413) {
            _this.$notify.error({
              title: "创建失败,异常提示:",
              message:
                "文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
            });
          } else if (res.data.success) {
            //添加到备注列表
            if (res.data.data) {
              _this.orderRemarks.unshift(res.data.data);
              _this.$notify.success({
                title: "成功",
                message: "订单备注添加成功!"
              });
              _this.addOrderRemarksDialogVisible = false;
            }
            //清空
            // _this.orderRemarksForm.orderId="";
            _this.orderRemarksForm.event = "";
            _this.orderRemarksForm.content = "";
            _this.addImg = "";
            _this.imgFile = [];
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          if (error.response.status === 413) {
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message:
                "文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
            });
          } else {
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message: error.response.statusText,
              duration: 0
            });
          }
        });
    },
    imgChange(file, fileList) {
      this.addImg = file.raw;
    },
    downloadCartonLabel() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$notify({
          title: "提示",
          message: "请选择订单",
          type: "warning"
        });
        return false;
      }
    },
    invoiceTemplateExport(id, detainGoods, searchException, customerName) {
      //超安达模板下载
      this.$windowOpen1(
        '/order/download/invoiceTemplate' +
          "?orderId=" +
          id +
          "&detainGoods=" +
          detainGoods +
          "&searchException=" +
          searchException +
          "&customerName=" +
          customerName
      );
    },
    invoiceTemplateExport2() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$notify({
          title: "提示",
          message: "请选择订单",
          type: "warning"
        });
        return false;
      }
      let arrayId = [];
      for (let i = 0; i < this.multipleSelection.length; i++) {
        arrayId.push(this.multipleSelection[i].id);
      }
      //超安达模板下载
      // this.$windowOpen1(
      //   '/order/download/invoiceTemplate2' +
      //     "?orderId=" +
      //     arrayId.join(",")
      // );

      this.$request1({
          url: '/order/download/invoiceTemplate2',
          method: 'post',
          data: arrayId
        }).then(res => {
          if(res.data.success && res.data.data!=null && res.data.data.length>0){
            
            const link = document.createElement('a')
            let array = base64ToUint8Array(res.data.data)
            let blob = new Blob([array])
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
            link.setAttribute('download', `invoice_${timestr}.xlsx`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }else{
            this.$message.error('没有数据');
          }          
        })


    },
    loadTmsOrderAuditStatus() {
      let _this = this;
      _this.$request1
        .get(
          '/order/auditStatus',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          // console.log(res);
          _this.tmsOrderAuditStatus = res.data;
        })
        .catch(function(error) {});
    },
    loadTmsOrderStages() {
      let _this = this;
      _this.$request1
        .get(
          '/order/tms-order-stage',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          // console.log(res);
          _this.tmsOrderStages = res.data;
        })
        .catch(function(error) {});
    },
    //多选按钮
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.disabledDetainGoodsBtn = true;
      this.disabledreleaseGoodsBtn = true;
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        this.multipleSelection.forEach((d, i) => {
          if (d.detainGoods) {
            this.disabledreleaseGoodsBtn = false;
          } else {
            this.disabledDetainGoodsBtn = false;
          }
        });
      }
    },
    //订单审核
    handleEdit(index, row) {
      this.checkForm = {
        orderId: row.id,
        index: index,
        audit: row.audit + "",
        auditRemark: row.auditRemark
      };
      this.dialogCheckVisible = true;
    },
    setingAudit(orderId) {
      var _this = this;
      this.$confirm("此操作将审核通过该订单，请仔细核对", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          _this.$request1
            .post(
              '/order/audit',
              {
                orderId: orderId
              },
              {
                withCredentials: true
              }
            )
            .then(function(res) {
              //console.log(res);
              if (res.data.success) {
                _this.$notify({
                  title: "提示",
                  message: "审核成功"
                });
                _this.onSubmit();
              } else {
                _this.$notify({
                  title: "提示",
                  message: res.data.message,
                  type: "error",
                  duration: 0
                });
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    batchAudit() {
      var _this = this;
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: "请选择需要审核的订单",
          type: "warning"
        });
        return;
      }
      let orderIds = [];
      let message = "";
      this.multipleSelection.forEach((item, index) => {
        if (!item.audit) {
          orderIds.push(item.id);
        } else {
          message += "<p>" + item.id + "</p>";
        }
      });

      this.$confirm("此操作将审核通过勾选的订单，请仔细核对", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (message !== "") {
            this.$notify.warning({
              title: "提示",
              dangerouslyUseHTMLString: true,
              message: "<p>以下订单已审核，请勿重复操作</p>" + message
            });
            return;
          }

          this.$request1({
              method: 'POST',
              url: '/order/batch/audit',
              headers: { "content-type": "application/json" },
              data: orderIds,
              responseType: "json"
            })
            .then(function(res) {
              if (res.data.success) {
                _this.$notify({
                  title: "提示",
                  message: "审核成功"
                });
                _this.onSubmit();
              } else {
                _this.$notify({
                  title: "提示",
                  message: res.data.message,
                  type: "error",
                  duration: 0
                });
              }
            })
            .catch(function(error) {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    //分页
    handleSizeChange(val) {
      this.conditions.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.conditions.currentPage = val;
      this.onSubmit();
    },
    findByCustomerName() {
      let _this = this;
      _this.$request1
        .get(
          '/customer/filter',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          //console.log(res.data);
          if (res.data.success) {
            _this.customerList = res.data.data;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    findAllChannle() {
      this.$request1({
        method: 'GET',
        url: '/system/channel/all'
      })
        .then(response => {
          // console.log(response);
          this.channelDatas = response.data;
          this.channelDatasMap = {};
          this.channelDatas.forEach(a => {
            this.channelDatasMap[a.id] = a.name;
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    queryProvinceOfChina() {
      var _this = this;
      _this.$request1
        .get(
          '/province/' + 1 + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataProvince = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    queryCity() {
      var _this = this;
      let _provinceId = "";
      _this.initialDataProvince.forEach((d, i) => {
        if (d.nameCn == _this.shippingForm.province) {
          _provinceId = d.id;
        }
      });
      _this.$request1
        .get(
          '/city/' + _provinceId + '',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.status == 200 && response.data.success) {
            _this.initialDataCity = response.data.data;
          } else {
            _this.$message.error("加载初始化数据失败");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getCustomerChannel(isUpdate) {
      this.channelData = [];
      this.createOrderform.product = "";
      this.uploadForm.product = "";
      let orgOwnerId = isUpdate
        ? this.uploadForm.customer
        : this.createOrderform.customer;
      this.$request1({
        method: 'GET',
        url: '/channel/getChannel',
        params: {
          orgOwnerId: orgOwnerId
        }
      })
        .then(response => {
          this.channelData = response.data;
          //加载上传订单框客户地址
          this.queryAddress("SHIPPING", orgOwnerId);
          this.queryWarehouse(orgOwnerId);
        })
        .catch(error => {
          console.log(error);
        });
    },
    findingOrderStage(val) {
      if (val && val.length > 0) {
        let _stageName = "新增";
        val.forEach((d, i) => {
          if (d.passed) {
            _stageName = "已" + d.stageName;
          }
        });
        return _stageName;
      } else {
        return "无流程";
      }
    },
    downloadAttachment(id, detainGoods, searchException) {
      //下载附件
      this.$windowOpen1(
        '/order/download/attachment' +
          "?orderId=" +
          id +
          "&detainGoods=" +
          detainGoods +
          "&searchException=" +
          searchException
      );
    },
    downloadCustomsDocuments(id) {
      this.$windowOpen1(
        '/order/download/customs' +
          "?orderId=" +
          id
      );
    },

    showTrackingNumber(row) {
      let _this = this;
      this.showTrackingNumberWindow = true;
      this.trackingNumbers = row.trackingNumbers;
      this.setManualTrackingNumbers(row.manualTrackingNumbers);
    },

    //转单操作 弹框
    transferNumberPop() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$notify({
          title: "提示",
          message: "请选择订单",
          type: "warning"
        });
        return false;
      }
      this.transferForm.items = [];
      for (let i = 0; i < this.multipleSelection.length; i++) {
        this.transferForm.items.push({
          number: this.multipleSelection[i].id,
          trackingNumber: ""
        });
      }
      this.transferNumberVisible = true;
    },
    //确认发货
    confirmShipping() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$notify({
          title: "提示",
          message: "请选择订单",
          type: "warning"
        });
        return false;
      }
      var formData = { orderIds: [] };

      for (let i = 0; i < this.multipleSelection.length; i++) {
        formData.orderIds.push(this.multipleSelection[i].id);
      }
      this.$request1({
        url: 'op/api/order/batch-confirm-delivery',
        method: "post",
        data: formData,
        withCredentials: true,
        headers: { "Content-Type": "application/json" }
      })
        .then(function(res) {
          if (res.data.succeed) {
            if (res.data.message != null) {
              _this.$alert(res.data.message, "提示");
              return;
            }
            var t = "";
            res.data.responses.forEach(a => {
              if (a.succeed) {
                setTimeout(() => {
                  _this.search(); //成功后就刷新
                }, 1500);
                t += "订单" + a.orderId + "确认发货成功！<br>";
              } else {
                t += "订单" + a.orderId + a.message + "<br>";
              }
            });

            _this.$alert(t, {
              title: "提示",
              dangerouslyUseHTMLString: true
            });
          } else {
            _this.$alert(res.data.message, "异常提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    goodsInfoExport() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$notify({
          title: "提示",
          message: "请选择订单",
          type: "warning"
        });
        return false;
      }
      let arrayId = [];
      for (let i = 0; i < this.multipleSelection.length; i++) {
        arrayId.push(this.multipleSelection[i].id);
      }
      // var url = tmsSpringUrl + '/order/goods-info';
      // var form = document.getElementById("myform");
      // form.setAttribute("action", url);
      // var fhtml = "";
      // fhtml +=
      //   '<input type="hidden" name="orderIds" value="' +
      //   arrayId.join(",") +
      //   '" />';

      //   fhtml +=
      //   '<input type="hidden" name="token" value="' +
      //   this.$getToken() +
      //   '" />';
      // form.innerHTML = fhtml;
      // //console.log(form);
      // form.submit();

      let formData = {
        orderIds: arrayId.join(","),
        type: ""
      }
      this.$request1({
          url: '/order/goods-info',
          method: 'post',
          data: formData
        }).then(res => {
          if(res.data.success && res.data.data!=null && res.data.data.length>0){
            
            const link = document.createElement('a')
            let array = base64ToUint8Array(res.data.data)
            let blob = new Blob([array])
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
            link.setAttribute('download', `goods_info_${timestr}.xlsx`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }else{
            this.$message.error('没有数据');
          }          
        })


    },
    closeTransferPanel() {
      this.transferNumberVisible = false;
      this.onSubmit();
    },
    calculateTotalWeight(row) {
      let totalWeight = 0;
      if (row.packingList.cartonDetails) {
        row.packingList.cartonDetails.forEach((d, i) => {
          totalWeight += d.weight;
        });
      }
      return this.toFixed(totalWeight, 4);
    },
    calculateTotalActuallyWeight(row) {
      let totalWeight = 0;
      if (row.packingList.cartonDetails) {
        row.packingList.cartonDetails.forEach((d, i) => {
          totalWeight += d.actuallyWeight;
        });
      }
      return this.toFixed(totalWeight, 4);
    },
    toFixed(num, len) {
      if (!num || isNaN(num)) {
        return "";
      }
      var times = Math.pow(10, len);
      var des = num * times + 0.5;
      return parseInt(des, 10) / times;
    },

    detainGoods(isConfirm) {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$notify({
          title: "提示",
          message: "请选择订单",
          type: "warning"
        });
        return false;
      }
      let _orderIds = new Array();
      this.multipleSelection.forEach((d, i) => {
        _orderIds.push(d.id);
      });
      if (isConfirm) {
        _this.detainGoodsConfirm(_orderIds, isConfirm);
      } else {
        _this
          .$confirm(
            "扣货后,订单的运力分配前的流程可以正常流转,订单测量完成后不会出现在运力分配页面, 是否继续?",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          )
          .then(() => {
            _this.detainGoodsConfirm(_orderIds, isConfirm);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
      }
    },
    detainGoodsConfirm(_orderIds, isConfirm) {
      let _this = this;
      _this.$request1
        .post(
          '/order/detain-goods',
          {
            orderIds: _orderIds,
            detainGoods: true,
            confirm: isConfirm
          },
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          //console.log(res);
          if (res.data.success) {
            if (res.data.message && res.data.message.length > 0) {
              _this
                .$confirm(res.data.message, "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                })
                .then(() => {
                  _this.detainGoods(true);
                })
                .catch(() => {
                  _this.$notify({
                    type: "info",
                    message: "已取消"
                  });
                });
            } else {
              _this.$notify({
                title: "提示",
                message: "扣货成功"
              });
              _this.onSubmit();
            }
          } else {
            _this.$notify({
              title: "提示",
              message: res.data.message,
              type: "error",
              duration: 0
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    backOrder() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$notify({
          title: "提示",
          message: "请选择订单",
          type: "warning"
        });
        return false;
      }
      let _orderIds = new Array();
      this.multipleSelection.forEach((d, i) => {
        _orderIds.push(d.id);
      });
      this.$confirm("此操作将订单状态改为退件状态, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          _this.$request1
            .post(
              '/order/backOrderOperation',
              {
                orderIds: _orderIds,
                detainGoods: true,
                refund: true
              },
              {
                withCredentials: true
              }
            )
            .then(function(res) {
              //console.log(res);
              if (res.data.success) {
                _this.$notify({
                  title: "提示",
                  message: "退件成功"
                });
                _this.onSubmit();
              } else {
                _this.$notify({
                  title: "提示",
                  message: res.data.message,
                  type: "error",
                  duration: 0
                });
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    releaseGoods() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$notify({
          title: "提示",
          message: "请选择订单",
          type: "warning"
        });
        return false;
      }
      let _orderIds = new Array();
      this.multipleSelection.forEach((d, i) => {
        _orderIds.push(d.id);
      });
      this.$confirm(
        "此操作将已经被扣货的订单放行以继续流转, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          _this.$request1
            .post(
              '/order/detain-goods',
              {
                orderIds: _orderIds,
                detainGoods: false
              },
              {
                withCredentials: true
              }
            )
            .then(function(res) {
              //console.log(res);
              if (res.data.success) {
                _this.$notify({
                  title: "提示",
                  message: "扣货放行成功"
                });
                _this.onSubmit();
              } else {
                _this.$notify({
                  title: "提示",
                  message: res.data.message,
                  type: "error",
                  duration: 0
                });
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    downloadGoodsInfo() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$notify({
          title: "提示",
          message: "请选择订单",
          type: "warning"
        });
        return false;
      }
      let ids = new Array();
      this.multipleSelection.forEach((d, i) => {
        ids.push(d.id);
      });
      // this.$windowOpen1(
      //   '/batch-operation/download/goodsinfo' +
      //     "?ids=" +
      //     ids.toString() +
      //     "&type=order"
      // );

      this.$request1({
          url: '/batch-operation/download/goodsinfo',
          method: 'post',
          data: {
            ids: ids,
            type: 'order'
          }
        }).then(res => {
          if(res.data.success && res.data.data!=null && res.data.data.length>0){
            
            const link = document.createElement('a')
            let array = base64ToUint8Array(res.data.data)
            let blob = new Blob([array])
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
            link.setAttribute('download', `订单信息表导出_${timestr}.xlsx`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }else{
            this.$message.error('没有数据:' + res.data.message);
          }          
        })
    },
    wuyoubao() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$notify({
          title: "提示",
          message: "请选择订单",
          type: "warning"
        });
        return false;
      }
      let ids = new Array();
      this.multipleSelection.forEach((d, i) => {
        ids.push(d.id);
      });
      this.$request1.post('d/wuyoubao',
      {
        ids: ids
      },
      {
        withCredentials: true,
      }
      ).then(function(response) {
        if (response.status == 200 && response.data.success) {
            const link = document.createElement('a')
            const array = base64ToUint8Array(response.data.data)
            const blob = new Blob([array])
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.setAttribute('download', `无忧保.xlsx`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
      })
    },
    // 导出fbanumber-excel
    exportFbaNumber(){
      if(this.fbaNumberList.length == 0){
        this.$message.error('没有数据')
        return
      }
      let orderId = this.fbaNumberList[0].orderId

      this.$request1({
        method: 'get',
        url: `pda/export-carton-number`,
        params: {
          orderId: orderId
        }
      }).then((res) => {
        if (res.data.success) {
          const link = document.createElement('a')
          let array = base64ToUint8Array(res.data.data)
          let blob = new Blob([array])
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)

          let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
          link.setAttribute('download', `fbaNumber_${orderId}_${timestr}.xlsx`)

          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        } else {
          this.$message.error('下载失败：' + res.data.message)
        }
      })


    },
    // 弹出fbanumber框
    showFbaNumberPop(orderId){
      this.fbaNumberList = []
      this.$request1({
        method: 'get',
        url: `pda/query-carton-number`,
        params: {
          orderId: orderId
        }
      }).then(res => {
        if(res.data.success){
          this.fbaNumberList = res.data.data
          this.dialogFbaNumberVisible = true
        }else{
          this.$message.error(res.data.message)
        }
      })
    },
    measureImage(id) {
      let _this = this
      this.$request1.get('d/measure-image?orderId=' + id,
      {
        withCredentials: true,
      }
      ).then(function(response) {
        if (response.status == 200 && response.data.success) {
            const link = document.createElement('a')
            const array = base64ToUint8Array(response.data.data)
            const blob = new Blob([array])
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.setAttribute('download', id + `.zip`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }else{
          _this.$message.error(response.data.message)
        }
      })
    },
    downloadInTheOrderInfo() {
      this.$windowOpen1(
        '/order/order-info'
      );
    },
    generatedReportByCustomer() {
      let _this = this;

      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        // 取消一次性导出所有数据
        this.$message.warning({
          message: "请选择需要导出的订单！"
        });
        return;
        
      } else {
        //导出选中的客户
        let ids = new Array();
        this.multipleSelection.forEach((d, i) => {
          ids.push(d.id);
        });
        var form = document.getElementById("exportform");
        var url = tmsSpringUrl + '/order/generated-reportByCustomer';
        form.setAttribute("action", url);
        // form.setAttribute("method", "get");
        var fhtml = "";
        fhtml +=
          '<input type="hidden" name="orderIds" value="' +
          ids.join(",") +
          '" />';
          fhtml +=
        '<input type="hidden" name="token" value="' +
        this.$getToken() +
        '" />';
        form.innerHTML = fhtml;
        form.submit();
      }
    },
    trackingNoExport() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        this.$message.warning("请选择需要导出的订单！");
        return;
      }
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        //导出所有的客户
        _this.conditions.export = 2;
        // var fhtml = _this.formToHtml();
        // var form = document.getElementById("myform");
        // var url = tmsSpringUrl + '/order/query';
        // form.setAttribute("action", url);

        // fhtml +=
        // '<input type="hidden" name="token" value="' +
        // this.$getToken() +
        // '" />';

        // form.innerHTML = fhtml;
        // form.submit();
        let params = this.handleConditionsData();
        this.$request1({
          url: '/order/query',
          method: 'post',
          data: params
        }).then(res => {
          if(res.data.success && res.data.data!=null && res.data.data.length>0){
            _this.conditions.export = 0

            const link = document.createElement('a')
            let array = base64ToUint8Array(res.data.data)
            let blob = new Blob([array])
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
            link.setAttribute('download', `tracking_no_${timestr}.xlsx`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }else{
            this.$message.error('没有数据');
          }          
        })

      } else {
        //导出选中的客户
        let ids = new Array();
        this.multipleSelection.forEach((d, i) => {
          ids.push(d.id);
        });
        // var form = document.getElementById("exportform");
        // var url = tmsSpringUrl + '/order/tracking-no-export';
        // form.setAttribute("action", url);
        // var fhtml = "";
        // fhtml +=
        //   '<input type="hidden" name="orderIds" value="' +
        //   ids.join(",") +
        //   '" />';
          
        //   fhtml +=
        // '<input type="hidden" name="token" value="' +
        // this.$getToken() +
        // '" />';
        // form.innerHTML = fhtml;
        // form.submit();
        this.$request1({
          url: '/order/tracking-no-export',
          method: 'post',
          data: ids
        }).then(res => {
          if(res.data.success && res.data.data!=null && res.data.data.length>0){
            
            const link = document.createElement('a')
            let array = base64ToUint8Array(res.data.data)
            let blob = new Blob([array])
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
            link.setAttribute('download', `tracking_no_${timestr}.xlsx`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }else{
            this.$message.error('没有数据');
          }          
        })
      }
    },
    formToHtml() {
      let params = this.handleConditionsData();

      delete params.currentPage;
      delete params.pageSize;
      delete params.sysOwner;
      delete params.saleman;
      delete params.serviceStaff;
      delete params.warehouseIds;

      var fhtml = "";
      for (var key in params) {
        if (
          key != "orgOwners" &&
          key != "salesmans" &&
          key != "wildcardTexts" &&
          key != "customerServiceStaffs" &&
          key != "trackingNumber" &&
          key != "customerOrderNumber" &&
          key != "batchId" &&
          key != "orderId" &&
          key != "productIds" &&
          key != "fbaNumber" &&
          key != "stages"
        ) {
          fhtml +=
            '<input type="hidden" name="' +
            key +
            '" value="' +
            (params[key] == null ? "" : params[key]) +
            '" />';
        }
      }
      if (this.conditions.stages.length > 0) {
        this.conditions.stages.forEach(a => {
          fhtml += '<input type="hidden" name="stages[]" value="' + a + '" />';
        });
      }
      if (this.conditions.orgOwner.length > 0) {
        this.conditions.orgOwner.forEach(a => {
          fhtml +=
            '<input type="hidden" name="orgOwners[]" value="' + a + '" />';
        });
      }
      if (this.conditions.salesmans.length > 0) {
        this.conditions.salesmans.forEach(a => {
          fhtml +=
            '<input type="hidden" name="salesmans[]" value="' + a + '" />';
        });
      }
      if (params.wildcardTexts.length > 0) {
        params.wildcardTexts.forEach(a => {
          fhtml +=
            '<input type="hidden" name="wildcardTexts[]" value="' + a + '" />';
        });
      }
      if (this.conditions.customerServiceStaffs.length > 0) {
        this.conditions.customerServiceStaffs.forEach(a => {
          fhtml +=
            '<input type="hidden" name="customerServiceStaffs[]" value="' +
            a +
            '" />';
        });
      }
      if (params.trackingNumber.length > 0) {
        params.trackingNumber.forEach(a => {
          fhtml +=
            '<input type="hidden" name="trackingNumber[]" value="' + a + '" />';
        });
      }
      if (params.customerOrderNumber.length > 0) {
        params.customerOrderNumber.forEach(a => {
          fhtml +=
            '<input type="hidden" name="customerOrderNumber[]" value="' +
            a +
            '" />';
        });
      }
      if (params.batchId.length > 0) {
        params.batchId.forEach(a => {
          fhtml += '<input type="hidden" name="batchId[]" value="' + a + '" />';
        });
      }
      if (params.fbaNumber.length > 0) {
        params.fbaNumber.forEach(a => {
          fhtml +=
            '<input type="hidden" name="fbaNumber[]" value="' + a + '" />';
        });
      }
      if (params.orderId.length > 0) {
        params.orderId.forEach(a => {
          fhtml += '<input type="hidden" name="orderId[]" value="' + a + '" />';
        });
      }
      if (this.conditions.product.length > 0) {
        this.conditions.product.forEach(a => {
          fhtml +=
            '<input type="hidden" name="productIds[]" value="' + a + '" />';
        });
      }
      return fhtml;
    },
    // 取消订单
    cancelOrder(index, row) {
      this.$confirm("确定要取消该订单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$request1({
            method: 'post',
            url: '/order/canceled-order',
            params: {
              orderId: row.id,
              refNumber: row.customerOrderNumber,
              orgOwner: row.orgOwner
            },
            withCredentials: true
          })
            .then(response => {
              if (response.data.success) {
                if(response.data.message==null) {
                  this.returnMessage=''
                } else {
                  this.returnMessage=response.data.message
                }
                this.$notify({
                  title: "成功",
                  message: "订单号：" + row.id + "取消成功" + this.returnMessage,
                  type: "success"
                });
              } else {
                this.$notify({
                  title: "失败",
                  message: response.data.message,
                  type: "error"
                });
              }
              this.initData();
            })
            .catch(error => {
              console.log(error);
              this.$message.error("操作失败");
            });
        })
        .catch(() => {});
    },
    // 添加异常订单
    addExceptionOrder(index, row) {
      let tips = "";
      if (!row.nonSysException) {
        tips = "确定要添加为异常订单吗？";
      } else {
        tips = "确定要将异常订单转化为正常吗？";
      }
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(row);
          this.$request1({
            method: 'post',
            url: '/order/addExceptionOrder',
            params: {
              orderId: row.id,
              refNumber: row.customerOrderNumber,
              orgOwner: row.orgOwner,
              nonSysException: row.nonSysException
            },
            withCredentials: true
          })
            .then(response => {
              if (response.data.success) {
                var msg = "";
                if (!row.nonSysException) {
                  msg = "订单号：" + row.id + "已添加为异常订单";
                } else {
                  msg = "订单号：" + row.id + "已转为正常订单";
                }
                this.$notify({
                  title: "成功",
                  message: msg,
                  type: "success"
                });
              } else {
                this.$notify({
                  title: "失败",
                  message: response.data.message,
                  type: "error"
                });
              }
              this.initData();
            })
            .catch(error => {
              console.log(error);
              this.$message.error("操作失败");
            });
        })
        .catch(() => {});
    },
    //编辑上传订单
    editUploadOrder(row) {
      let querydeliveryDetail = row.deliveryDetail;
      let deliAddress = querydeliveryDetail.address;

      this.editForm = {
        orderId: row.id,
        orgOp: row.orgOp,
        orgOwner: row.orgOwner,
        warehousCode: row.warehousCode,
        productId: row.product,
        product: row.productName,
        remark: row.remark,
        customerRefnumber: row.customerRefnumber,
        deliveryDetail: {
          deliveryType: querydeliveryDetail.deliveryType,
          warehouseCode: querydeliveryDetail.warehouseCode,
          appointmentAt: new Date(querydeliveryDetail.appointmentAt),

          expressCompany: querydeliveryDetail.shipment.provider,
          expressNumber: querydeliveryDetail.shipment.trackingNumber,

          contractName: querydeliveryDetail.contractDatail.name,
          phone: querydeliveryDetail.contractDatail.phone,

          country: deliAddress.country,
          province: deliAddress.province,
          provinceId: deliAddress.province,
          city: deliAddress.city,
          addressFirst: querydeliveryDetail.address.address
        }
      };
      this.dialogCheckVisibleEditUpload = true;
    },
    //订单上传更新
    editUploadOrderInfo() {
      var _this = this;
      var formData = new FormData();
      if (!_this.editForm.orderId) {
        _this.$notify({
          title: "提示",
          message: "请选择订单",
          type: "warning"
        });
        return false;
      } else {
        formData.append("orderId", _this.editForm.orderId);
      }
      if (!_this.templateFile || _this.templateFile.length == 0) {
        _this.$notify({
          title: "提示",
          message: "请选择文件",
          type: "warning"
        });
        return false;
      } else {
        formData.append("template", _this.templateFile);
      }
      this.$confirm("您确定要更新上传订单吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$request1({
            url: '/order/edit-upload',
            method: "post",
            data: formData,
            withCredentials: true,
            headers: { "Content-Type": "multipart/form-data" }
          })
            .then(function(res) {
              //console.log(res);
              if (res.data.success) {
                _this.$notify({
                  title: "提示",
                  message: "更新成功"
                });
                callback: action => {
                  _this.$router.push("/order");
                };
                _this.templateFile = "";
                _this.fileList = [];
                _this.dialogCheckVisibleEditUpload = false;
                _this.onSubmit();
              } else {
                _this.$notify({
                  title: "提示",
                  message: res.data.message,
                  type: "error",
                  duration: 0
                });
                callback: action => {};
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    showDialogUpLoadDialog() {
      // 显示上传订单窗口
      let _this = this;
      _this.dialogUpLoadVisible = true;
      //初始化数据
      this.uploadForm = {
        orgOwner: "",
        orgOp: "",
        customer: "",
        product: "",
        productType: "",
        productCountry: "",
        warehouseId: "",
        customsId: "",
        deliveryDetail: {
          deliveryType: "PICK_UP_FROM_CUSTOMER",
          warehouseCode: "",
          appointmentAt: new Date(),
          expressCompany: "",
          expressNumber: "",
          contractName: "",
          phone: "",
          country: "",
          province: "",
          city: "",
          addressFirst: ""
        }
      };
      this.templateFile = "";
      this.fileList = [];
      this.channelData = [];
      this.shippingList = [];
    },
    changedeliveryType(v) {
      let _this = this;
      if (_this.currentWarehouseAddress && _this.currentWarehouseAddress.id) {
        if (v == "DELIVERY" || v == "DELIVERY_BY_EXPRESS") {
          //送货到仓库
          _this.uploadForm.warehoustId = _this.currentWarehouseAddress.id;
          _this.uploadForm.deliveryDetail.warehouseCode =
            _this.currentWarehouseAddress.id;
          _this.uploadForm.deliveryDetail.contractName =
            _this.currentWarehouseAddress.receiptPersonName;
          _this.uploadForm.deliveryDetail.phone =
            _this.currentWarehouseAddress.receiptPersonPhone;
          _this.uploadForm.deliveryDetail.country =
            _this.currentWarehouseAddress.countryCode;
          _this.uploadForm.deliveryDetail.province =
            _this.currentWarehouseAddress.province;
          _this.uploadForm.deliveryDetail.city =
            _this.currentWarehouseAddress.city;
          _this.uploadForm.deliveryDetail.addressFirst =
            _this.currentWarehouseAddress.address;
        } else if (v == "PICK_UP_FROM_CUSTOMER") {
          //上门取件
          _this.uploadForm.deliveryDetail.contractName = "";
          _this.uploadForm.deliveryDetail.phone = "";
          _this.uploadForm.deliveryDetail.country = "";
          _this.uploadForm.deliveryDetail.province = "";
          _this.uploadForm.deliveryDetail.city = "";
          _this.uploadForm.deliveryDetail.addressFirst = "";

          if (_this.shippingList && _this.shippingList.length > 0) {
            let _find = false;
            _this.shippingList.forEach((d, i) => {
              if (d.defaultAddress) {
                _find = true;
                _this.selectShippingAddress(d.id);
              }
            });
            if (!_find) {
              _this.selectShippingAddress(_this.shippingList[0].id);
            }
          }
        }
      } else {
      }
    },
    closeUploadFile() {
      this.templateFile = "";
      this.$refs.uploadExcel.clearFiles();
      this.dialogUpLoadVisible = false;
    },
    fileChange(file, fileList) {
      this.templateFile = file.raw;
    },
    exceedFile(file, fileList) {
      fileList[0].name = file[0].name;
      fileList[0].raw = file[0];
      fileList[0].size = file[0].size;
      this.templateFile = file[0];
    },
    addressDialogPop() {
      if (!this.uploadForm.customer) {
        this.$notify({
          title: "提示",
          message: "请选择客户",
          type: "warning"
        });
        return false;
      }
      this.shippingForm = {
        orgOwner: this.uploadForm.customer,
        id: "",
        country: "中国",
        province: "",
        city: "",
        fbacode: "",
        address: "",
        name: "",
        phone: "",
        zipcode: "",
        type: "SHIPPING",
        defaultAddress: false
      };
      this.addressDialogVisible = true;
    },
    //编辑地址
    handleEditAddress(index, row) {
      this.addressFormVisible = true;
    },
    selectWarehouse() {
      this.warehouseData.forEach((item, index) => {
        if (item.id == this.warehouseId) {
          this.getMapForm(item);
          this.userCarry[0].title = item.name;
          this.userCarry[0].address = item.address;
          this.userCarry[0].name = item.receiptPersonName;
          this.userCarry[0].phone = item.phone;
        }
      });
    },
    queryAddress(type, orgOwner) {
      //查找客户的地址
      let _this = this;
      this.$request1({
        method: 'GET',
        url: '/org/address',
        params: {
          type: type,
          orgOwner: orgOwner
        }
      })
        .then(res => {
          this.shippingList = [];
          this.shippingId = "";
          if (res.data.success) {
            if (res.data.data && res.data.data.length > 0) {
              this.shippingList = res.data.data;
              this.selectShippingAddress(this.shippingList[0].id);
              this.shippingList.forEach((d, i) => {
                if (d.defaultAddress) {
                  this.selectShippingAddress(d.id);
                }
              });
            }
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    closeAddressPanel() {
      this.addressDialogVisible = false;
      this.queryAddress("SHIPPING", this.uploadForm.customer);
    },
    queryWarehouse(orgOwner) {
      //查找客户分配的仓库
      this.$request1({
        method: 'GET',
        url: '/warehouse/customer-owner',
        params: {
          orgOwner: orgOwner
        }
      })
        .then(response => {
          console.log(response);
          this.warehouseData = [];
          this.warehouseId = "";
          if (response.data.success) {
            if (response.data.data && response.data.data.length > 0) {
              this.warehouseData = response.data.data;
              this.flag = true;
              this.getMapForm(this.warehouseData[0]);
              if (this.warehouseData.length == 1) {
                this.flag = false;
              }
              // this.warehouse = [];
              // response.data.data.forEach((d, i) => {
              //   d.title = d.name;
              //   d.position = d.position.split(",");

              //   let warehouse = { id: "", title: "" };
              //   warehouse.id = d.id;
              //   warehouse.title = d.name;
              //   this.warehouse.push(warehouse);
              // });
              // this.initialDataWarehouseAddress = response.data.data;
              // this.currentWarehouseAddress = response.data.data[0];
              this.warehouseId = this.warehouseData[0].id;
            }
          } else {
            _this.$message.error(response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    selectShippingAddress(id) {
      this.shippingList.forEach((d, i) => {
        if (d.id == id) {
          this.shippingId = id;
          this.uploadForm.deliveryDetail.province = d.province;
          this.uploadForm.deliveryDetail.city = d.city;
          this.uploadForm.deliveryDetail.addressFirst = d.address;
          this.uploadForm.deliveryDetail.contractName = d.name;
          this.uploadForm.deliveryDetail.phone = d.phone;
        }
      });
    },
    //点击仓库
    getMapForm(val) {
      this.currentWarehouseAddress = val;
      this.uploadForm.warehouseId = val.id;
      if (
        this.uploadForm.deliveryDetail.deliveryType == "DELIVERY" ||
        this.uploadForm.deliveryDetail.deliveryType == "DELIVERY_BY_EXPRESS"
      ) {
        this.uploadForm.deliveryDetail.warehouseCode = val.id;
        this.uploadForm.deliveryDetail.contractName = val.receiptPersonName;
        this.uploadForm.deliveryDetail.phone = val.receiptPersonPhone;
        this.uploadForm.deliveryDetail.country = val.countryCode;
        this.uploadForm.deliveryDetail.province = val.province;
        this.uploadForm.deliveryDetail.city = val.city;
        this.uploadForm.deliveryDetail.addressFirst = val.address;
      }
      if (this.isInit) {
        this.userCarry[0].title = val.name;
        this.userCarry[0].address = val.address;
        this.userCarry[0].name = val.receiptPersonName;
        this.userCarry[0].phone = val.phone;
        this.userCarry[0].distance = val.distance;
        this.isInit = false;
      }
    },
    orderUpload() {
      let _this = this;
      var formData = new FormData();

      if (!this.uploadForm.customer) {
        this.$notify({
          title: "提示",
          message: "请选择客户",
          type: "warning"
        });
        return false;
      } else {
        formData.append("orgOwner", this.uploadForm.customer);
      }
      if (!this.uploadForm.product) {
        this.$notify({
          title: "提示",
          message: "请选择产品",
          type: "warning"
        });
        return false;
      } else {
        this.channelData.forEach((d, i) => {
          if (_this.uploadForm.product == d.id) {
            formData.append("productType", d.channelType);
            formData.append("productCountry", d.countryCode);
            formData.append("productId", d.id);
          }
        });
      }
      if (!_this.uploadForm.warehouseId) {
        this.$notify({
          title: "提示",
          message: "请选择仓库",
          type: "warning"
        });
        return false;
      } else {
        formData.append("warehouseId", _this.uploadForm.warehouseId);
        formData.append("orgOp", this.currentWarehouseAddress.orgOp);
      }

      if (!_this.templateFile || _this.templateFile.length == 0) {
        this.$notify({
          title: "提示",
          message: "请选择文件",
          type: "warning"
        });
        return false;
      } else {
        formData.append("template", _this.templateFile);
      }

      formData.append(
        "deliveryType",
        _this.uploadForm.deliveryDetail.deliveryType
      );
      if (
        _this.uploadForm.deliveryDetail.deliveryType ==
          "PICK_UP_FROM_CUSTOMER" &&
        (!_this.uploadForm.deliveryDetail.appointmentAt ||
          !_this.uploadForm.deliveryDetail.phone ||
          !_this.uploadForm.deliveryDetail.contractName ||
          !_this.uploadForm.deliveryDetail.province ||
          !_this.uploadForm.deliveryDetail.city ||
          !_this.uploadForm.deliveryDetail.addressFirst)
      ) {
        _this.$notify({
          title: "提示",
          message: "上门取货请填写上门取货的地址和预约时间",
          type: "warning"
        });
        return false;
      } else {
        //console.log(_this.uploadForm.deliveryDetail.appointmentAt);
        formData.set(
          "addressFirst",
          _this.uploadForm.deliveryDetail.addressFirst
        );
        formData.set(
          "appointmentAt",
          _this.uploadForm.deliveryDetail.appointmentAt.getTime()
        );
        formData.set(
          "contractName", _this.uploadForm.deliveryDetail.contractName
        );
        formData.append("expressCompany", "");
        formData.append("expressNumber", "");
        formData.set("phone", _this.uploadForm.deliveryDetail.phone);
        formData.set("province", _this.uploadForm.deliveryDetail.province);
        formData.set("city", _this.uploadForm.deliveryDetail.city);
      }
      if (
        _this.uploadForm.deliveryDetail.deliveryType == "DELIVERY" &&
        !_this.uploadForm.deliveryDetail.appointmentAt
      ) {
        _this.$notify({
          title: "提示",
          message: "送到仓库请选择预计送达时间",
          type: "warning"
        });
        return false;
      } else {
        formData.set(
          "addressFirst", _this.uploadForm.deliveryDetail.addressFirst
        );
        formData.set(
          "appointmentAt", _this.uploadForm.deliveryDetail.appointmentAt.getTime()
        );
        formData.set(
          "contractName", _this.uploadForm.deliveryDetail.contractName
        );
        formData.set("expressCompany", "");
        formData.set("expressNumber", "");
        formData.set("phone", _this.uploadForm.deliveryDetail.phone);
        formData.set("province", _this.uploadForm.deliveryDetail.province);
      }
      if (
        _this.uploadForm.deliveryDetail.deliveryType == "DELIVERY_BY_EXPRESS" &&
        (!_this.uploadForm.deliveryDetail.expressNumber ||
          !_this.uploadForm.deliveryDetail.expressCompany)
      ) {
        _this.$notify({
          title: "提示",
          message: "请填写快递单号和快递公司。",
          type: "warning"
        });
        return false;
      } else {
        formData.set(
          "addressFirst", _this.uploadForm.deliveryDetail.addressFirst
        );
        let appointmentAt = _this.uploadForm.deliveryDetail.appointmentAt;
        let oldTime = new Date(appointmentAt).getTime();
        formData.set("appointmentAt", oldTime);
        formData.set(
          "contractName",_this.uploadForm.deliveryDetail.contractName
        );
        formData.set(
          "expressCompany", _this.uploadForm.deliveryDetail.expressCompany
        );
        formData.set(
          "expressNumber", _this.uploadForm.deliveryDetail.expressNumber
        );
        formData.set("phone", _this.uploadForm.deliveryDetail.phone);
        formData.set("province", _this.uploadForm.deliveryDetail.province);
        formData.set("customsId", _this.uploadForm.customsId);
      }

      _this.$request1
        .post(
          '/order/upload',
          formData,
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.status == 413) {
            this.$notify.error({
              title: "创建订单失败,异常提示:",
              message:
                "Excel文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
            });
          } else if (response.data.success) {
            this.dialogUpLoadVisible = false;
            this.$notify.success({
              title: "创建订单成功,订单号为:",
              message: response.data.message,
              duration: 0
            });
            this.search();
          } else {
            this.$notify.error({
              title: "创建订单失败,异常提示:",
              message: response.data.message,
              duration: 0
            });
          }
          _this.templateFile = "";
        })
        .catch(error => {
          console.log(error);
          if (error.response.status === 413) {
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message:
                "文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
            });
          } else {
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message: error.response.statusText,
              duration: 0
            });
          }
        });
    },
    fahandleSaveAddress() {
      let _this = this;
      this.$refs["shippingForm"].validate(valid => {
        if (valid) {
          this.$request1({
            method: 'POST',
            url: '/org/address',
            data: this.shippingForm
          })
            .then(response => {
              if (response.data.success) {
                if (response.data.message == "create.shipping") {
                  this.$notify({
                    title: "成功",
                    message: "添加发件人地址成功",
                    type: "success"
                  });
                } else {
                  this.$notify({
                    title: "成功",
                    message: "修改发件人地址成功",
                    type: "success"
                  });
                }
                try {
                  _this.$emit("closeAddressPanel");
                } catch (err) {
                  console.error(err);
                }
              } else {
                this.$notify.error({
                  title: "错误",
                  message: response.data.message
                });
              }
              this.rulesForm(formName);
            })
            .catch(error => {
              console.log(error);
            });
          this.addressDialogVisible = false;
          this.getCustomerChannel(true);
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },

    addExceptionFollow() {
      this.dialogCheckVisible4 = true;
      this.trackingInfo.content = "";
      this.trackingInfo.createAt = "";
    },

    addExceptionFollowInfo() {
      let _this = this;
      if (
        this.trackingInfo.createAt == null ||
        this.trackingInfo.createAt == ""
      ) {
        _this.$alert("请填写时间。");
        return;
      }
      var date = this.trackingInfo.createAt.replace(/-/g, "/");
      var timestamp = new Date(date).getTime();

      if (_this.lastTrackTime != 0 && _this.lastTrackTime > timestamp) {
        _this.$alert("异常跟踪时间不能前于前面操作时间。");
        return;
      }
      if (this.trackingInfo.content == "") {
        _this.$alert("请填写描述。");
        return;
      }
      //console.log(this.trackingInfo.createAt);
      _this
        .$confirm("您确定要添加异常跟踪信息吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          var formData = new FormData();
          formData.append("data", JSON.stringify(_this.trackingInfo));
          this.$request1({
            url: '/order/addExceptionFollowInfo',
            method: "post",
            data: formData,
            withCredentials: true,
            headers: { "Content-Type": "multipart/form-data" }
          })
            .then(function(res) {
              if (res.data.success) {
                _this.$message.success("Success");
                _this.loadData(_this.trackingInfo.orderId);
              } else {
                _this.$message.error(res.data.message);
              }
              _this.dialogCheckVisible4 = false;
            })
            .catch(function(error) {
              _this.dialogCheckVisible4 = false;
              console.log(error);
            });
        });
    },

    editTrackingNumberPop(row, d) {
      this.newTrackingNumber = "";
      this.showEditTrackingNumber = true;
      this.theOrderId = row.id;
      this.theEditTrackingNumber = d;
    },
    editTrackingNumber() {
      let _this = this;

      if (!_this.newTrackingNumber || _this.newTrackingNumber.trim() == "") {
        _this.$notify({
          title: "提示",
          message: "转单号不能为空",
          type: "warning"
        });
        return;
      }
      _this.$request1
        .post(
          '/tracking-no/update',
          {
            orderId: _this.theOrderId,
            oldTrackingNo: _this.theEditTrackingNumber,
            newTrackingNo: _this.newTrackingNumber
          },
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          //console.log(res);
          if (res.data.success) {
            _this.$message.success("Success");
            _this.onSubmit();
            _this.showEditTrackingNumber = false;
          } else {
            _this.$alert(res.data.message);
          }
        })
        .catch(function(error) {
          //console.log(error);
          _this.$message.success(error.response.data);
        });
    },
    delTrackingNumber(row, d) {
      let _this = this;
      this.theOrderId = row.id;
      this.theEditTrackingNumber = d;

      _this
        .$confirm("是否删除转单号：" + d, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          _this.$request1
            .post(
              '/tracking-no/delete',
              {
                orderId: _this.theOrderId,
                trackingNo: _this.theEditTrackingNumber
              },
              {
                withCredentials: true
              }
            )
            .then(function(res) {
              //console.log(res);
              if (res.data.success) {
                _this.$message.success("Success");
                _this.onSubmit();
              } else {
                _this.$alert(res.data.message);
              }
            })
            .catch(function(error) {
              //console.log(error);
              _this.$message.success(error.response.data);
            });
        });
    },
    queryFbaAddress() {
      this.$request1
        .get(
          '/warehouse-address/query-all-fba',
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(response => {
          if (response.status == 200 && response.data.success) {
            let data = response.data.data;
            if (data != null && data.length > 0) {
              data.forEach((item, index) => {
                let fba = { code: "", name: "" };
                fba.code = item.warehouseCode;
                fba.name = item.warehouseCode;
                this.initialDataFbaAddress.push(fba);
              });
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 查看轨迹按钮  
    findTrack (data)  {
        this.TrackdialogShow=!this.TrackdialogShow
    },
    // 客户类型字典 
      getCustomerType() {
      this.$request1.get(
        '/customer/queryCustomerType'
      ).then(res => {
        if(res.data && res.data.length > 0) {
          this.customerTypeList = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
  }
};
</script>

<style lang="scss" scoped>
h3.sp-card-title {
  display: block !important;
}
.input-content {
  width: 70%;
  width: -webkit-calc(80% - 60px);
  width: -moz-calc(80% - 60px);
  width: -ms-calc(80% - 60px);
  width: calc(80% - 60px);
}

.el-dropdown-menu__item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  > i {
    padding: 0;
  }
  > span {
    width: 120px;
    text-align: right;
  }
  &.not-flex {
    display: block;
    .download-source {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #606266;
      &:hover,
      &:focus {
        background-color: #ecf5ff;
        color: #66b1ff;
      }
    }
  }
}
.template-btn {
  color: #409eff;
  margin-right: 15px;
  &:hover {
    text-decoration: underline;
  }
}
.table {
  width: 100%;
  thead tr th,
  tbody tr td {
    padding-left: 15px;
    // color: #99a9bf;
    border: 1px dotted #ebeef5;
  }
}
.download-icon,
.toggle-icon {
  color: rgb(58, 142, 230);
  &:hover {
    text-decoration: underline;
  }
  &.none:hover {
    text-decoration: none;
  }
}
.toggle-icon {
  margin-left: 15px;
  user-select: none;
  font-size: 12px;
  b {
    font-weight: 400;
  }
}
.require {
  position: relative;
  &::before {
    position: absolute;
    top: 7px;
    left: 25px;
    display: block;
    content: "*";
    color: red;
  }
}
.modal {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 99999;
  .modal-dialog {
    width: 100%;
    margin: 15% auto;
    transition: transform 0.3s ease-out;
    transform: translateY(-25%);
    .modal-content {
      position: relative;
      text-align: center;
      overflow: hidden;
      .img-wrapper {
        position: relative;
        display: inline-block;
        padding: 30px;
        .close {
          position: absolute;
          top: -5px;
          right: -30px;
          font-size: 30px;
          color: #f5f5f5;
          cursor: pointer;
        }
      }
    }
  }
}

.tracking-record__table {
  .record {
    display: flex;
    align-items: center;
    .detail {
      margin-right: 15px;
    }
    &.warning {
      color: #f56c6c;
    }
  }
}

.tracking-number__table {
  margin-top: 20px;
  thead tr th,
  tbody tr td {
    border-top: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
    &:last-child {
      border-right: 1px solid #ebeef5;
    }
  }
  thead tr th {
    padding: 12px;
  }
  tbody tr {
    td {
      padding: 6px 0;
      vertical-align: top;
      .item {
        height: 32px;
        line-height: 32px;
        padding: 0 12px;
        &:not(:first-child) {
          color: #99a9bf;
          border-top: 1px dashed #e5e5e5;
        }
        &.warning {
          color: #f56c6c;
        }
      }
    }
    & > :first-child {
      width: 48px;
      text-align: center;
      a {
        transition: all 0.3s;
      }
    }
    & > :first-child,
    & > :nth-child(2) {
      padding: 12px;
    }
  }
}
.active {
  color: red;
}
</style>


// WEBPACK FOOTER //
// src/views/order/order.vue